<template>
  <div class="index">
    <van-nav-bar title="发布病例" fixed left-arrow @click-left="$router.back()" style="z-index: 9999999" />
    <div class="index-head">
      <img src="@/assets/image/questionnaire/组 857@2x.png" />
    </div>
    <div class="biaodan">
      <el-form :model="form" :rules="rules" ref="form" class="form">
        <div class="inform">
          <!-- 患者基本系  v-show="informShow1"-->
          <div ref="inref">
            <div class="index-title">
              <div class="index-title-img">
                <img src="@/assets/image/questionnaire/组 747@2x.png" />
              </div>
              <div class="index-title-name">患者基本信息</div>
              <div class="index-title-xia"></div>
            </div>
            <!-- 身高体重年龄 -->
            <div class="inform-box">
              <el-form-item prop="name" ref="name">
                <div class="inform-box-item-flex">
                  <div class="inform-box-item-flex-name">患者姓名：</div>
                  <el-input v-model="form.name" placeholder="请输入姓名" />
                </div>
              </el-form-item>

              <el-form-item prop="age" ref="age">
                <div class="inform-box-item-flex">
                  <div class="inform-box-item-flex-name">年龄：</div>
                  <el-input v-model="form.age" placeholder="请输入年龄" />
                  <div class="inform-box-item-flex-input-rig">岁</div>
                </div>
              </el-form-item>

              <el-form-item prop="sex" ref="sex">
                <div class="inform-box-item-flex">
                  <div class="inform-box-item-flex-name">性别：</div>
                  <el-radio-group v-model="form.sex">
                    <el-radio :label="1" style="margin: 0 54px 0 0">男</el-radio>
                    <el-radio :label="2" style="margin-top: 0">女</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>

              <el-form-item prop="height" ref="height">
                <div class="inform-box-item-flex">
                  <div class="inform-box-item-flex-name">身高：</div>
                  <el-input v-model="form.height" placeholder="请输入身高" />
                  <div class="inform-box-item-flex-input-rig">cm</div>
                </div>
              </el-form-item>

              <el-form-item prop="weight" ref="weight" style="margin-bottom: 0">
                <div class="inform-box-item-flex">
                  <div class="inform-box-item-flex-name">体重：</div>
                  <el-input v-model="form.weight" placeholder="请输入体重" />
                  <div class="inform-box-item-flex-input-rig">kg</div>
                </div>
              </el-form-item>
            </div>
            <!-- 病例来源 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item prop="source" ref="source" label="病例来源：" style="margin: 8px 0 0 0">
                <el-radio-group v-model="form.source">
                  <el-radio :label="1">消化科</el-radio>
                  <el-radio :label="2">内科</el-radio>
                  <el-radio :label="3">心理科</el-radio>
                  <el-radio :label="4">其他</el-radio>
                </el-radio-group>
                <el-form-item prop="source_input" ref="source_input" v-if="form.source == 4">
                  <el-input class="form-input-xia" v-model="form.source_input" placeholder="请输入内容"
                    style="left: 20%"></el-input>
                </el-form-item>
              </el-form-item>
            </div>
            <!-- bim -->
            <div class="inform-box" style="margin-top: 10px">
              <div class="inform-box-title">BMI 情况：</div>
              <el-form-item prop="bim" ref="bim" label="BMI:" class="inform-box-lable">
                <el-input v-model="BMICom" placeholder="请输入BMI" :disabled="true" />
              </el-form-item>
              <el-form-item prop="bim_radio" ref="bim_radio" label="指标判断:" style="margin: 8px 0 0 0">
                <el-radio-group v-model="form.bim_radio" disabled>
                  <el-radio :label="1">体重过轻</el-radio>
                  <el-radio :label="2">正常体重</el-radio>
                  <el-radio :label="3">超重</el-radio>
                  <el-radio :label="4">一级肥胖</el-radio>
                  <el-radio :label="5">二级肥胖</el-radio>
                  <el-radio :label="6">三级肥胖</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <!-- 主诉症状 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item prop="symptom" ref="symptom" label="主诉症状：" style="margin: 8px 0 0 0">
                <el-checkbox-group v-model="form.symptom" style="margin-top: 10px" class="zhusu">
                  <el-checkbox label="2" name="type">腹胀</el-checkbox>
                  <el-checkbox label="3" name="type">嗳气</el-checkbox>
                  <el-checkbox label="4" name="type">早饱</el-checkbox>
                  <el-checkbox label="10" name="type">恶心</el-checkbox>
                  <el-checkbox label="6" name="type">呕吐</el-checkbox>

                  <el-checkbox label="8" name="type">腹部疼痛/不适</el-checkbox>

                  <el-checkbox label="7" name="type">食欲减退</el-checkbox>
                  <el-checkbox label="1" name="type">体重减轻</el-checkbox>
                  <el-checkbox label="9" name="type">焦虑抑郁</el-checkbox>
                  <el-checkbox label="5" name="type">餐后饱胀</el-checkbox>
                  <el-checkbox label="11" name="type">其他</el-checkbox>
                </el-checkbox-group>
                <el-form-item prop="symptom_input" ref="symptom_input" v-if="form.symptom.indexOf('11') != -1">
                  <el-input class="form-input-xia" v-model="form.symptom_input" placeholder="请输入内容"
                    style="left: 20%; top: -36px"></el-input>
                </el-form-item>
              </el-form-item>
            </div>
            <!-- 疾病状态 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item prop="disease_code" ref="disease_code" label="疾病状态：" style="margin: 8px 0 0 0">
                <el-radio-group v-model="form.disease_code">
                  <el-radio :label="1">新发</el-radio>
                  <el-radio :label="2">已确诊疾病</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <!-- 病程 -->
            <div class="inform-box" style="margin-top: 10px; padding-top: 0px">
              <el-form-item prop="course_disease" ref="course_disease" label="病程："
                style="margin: 8px 0 0 0; padding-top: 4px" class="inform-box-lable">
                <el-input v-model="form.course_disease" placeholder="请输入病程" type="textarea" />
              </el-form-item>
            </div>
            <!-- 饮酒史 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item label="饮酒史：" style="margin: 8px 0 0 0">
                <el-radio-group v-model="form.drink_alcohol">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="inform-box-fen" v-if="form.drink_alcohol == 1">
                <div class="inform-box-fen-left">
                  <div>饮酒量</div>
                  <el-form-item prop="drink_alcohol_quantity" ref="drink_alcohol_quantity" style="margin-top: 20px">
                    <el-input style="width: 60px" class="drink-alcohol-quantity-input"
                      v-model="form.drink_alcohol_quantity" />
                  </el-form-item>
                  <div>ml/日；</div>
                </div>
                <div class="inform-box-fen-right">
                  <div>饮酒频率</div>
                  <el-form-item prop="drink_alcohol_frequency" ref="drink_alcohol_frequency" style="margin-top: 20px">
                    <el-input style="width: 60px" class="drink-alcohol-quantity-input"
                      v-model="form.drink_alcohol_frequency" />
                  </el-form-item>
                  <div>次/周</div>
                </div>
              </div>
            </div>
            <!-- 吸烟史 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item label="吸烟史：" style="margin-bottom: 0">
                <el-radio-group v-model="form.smoking_history">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="inform-box-fen" v-if="form.smoking_history == 1">
                <div class="inform-box-fen-left">
                  <div>吸烟史</div>
                  <el-form-item prop="smoking_history_year" ref="smoking_history_year"
                    style="margin-top: 0px; margin-bottom: 0">
                    <el-input style="width: 60px" class="drink-alcohol-quantity-input"
                      v-model="form.smoking_history_year" />
                  </el-form-item>
                  <div>年；</div>
                </div>
                <div class="inform-box-fen-right">
                  <div>吸烟量</div>
                  <el-form-item prop="smoking_history_quantity" ref="smoking_history_quantity" style="margin-top: 20px">
                    <el-input style="width: 60px" class="drink-alcohol-quantity-input"
                      v-model="form.smoking_history_quantity" />
                  </el-form-item>
                  <div>根/日</div>
                </div>
              </div>
            </div>
            <!-- 家族史 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item label="家族史：" style="margin: 8px 0 0 0">
                <el-radio-group v-model="form.family_historyL">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <!-- 既往史 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item label="既往史：" style="margin: 8px 0 0 0">
                <el-radio-group v-model="form.past_historyL">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <!-- 其他既往病史 -->
            <div class="inform-box" style="margin-top: 10px; padding-top: 0px">
              <el-form-item label="其他既往病史：" style="margin: 8px 0 0 0; padding-top: 4px" class="inform-box-lable">
                <el-input v-model="form.medical_history" placeholder="请输入病程" type="textarea" />
              </el-form-item>
            </div>
            <!-- 过敏史 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item label="过敏史：" style="margin: 8px 0 0 0">
                <el-radio-group v-model="form.allergy">
                  <el-radio :label="1">无</el-radio>
                  <el-radio :label="2">有</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="inform-box-fen" v-if="form.allergy == 2">
                <el-form-item prop="allergy_input" ref="allergy_input" style="width: 100%; margin-bottom: 0">
                  <el-input v-model="form.allergy_input" placeholder="请输入过敏史" type="textarea" />
                </el-form-item>
              </div>
            </div>
            <!-- 既往检查 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item label="既往检查：" style="margin: 8px 0 0 0">
                <el-radio-group v-model="form.check">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="inform-box-jiancha" v-if="form.check == 1">
                <div class="inform-box-jiancha-title">检查项目：</div>
                <el-checkbox-group v-model="form.check_true">
                  <el-checkbox label="1" name="type" style="margin-bottom: 8px">体格检查</el-checkbox>
                  <div class="check-box-true-flex">
                    <el-checkbox label="2" name="type" @change="check_true_laboratoryClick">实验室检查结果：</el-checkbox>
                    <el-form-item prop="check_true_laboratory" ref="check_true_laboratory" style="margin-bottom: 20px">
                      <el-input :disabled="form.check_true.includes('2') == false" style="margin: 6px 0 0px 0"
                        v-model="form.check_true_laboratory" placeholder="请输入实验室检查结果" type="textarea" />
                    </el-form-item>
                  </div>
                  <div class="check-box-true-flex">
                    <el-checkbox label="3" name="type" @change="check_true_imageClick">影像学检查结果：</el-checkbox>
                    <el-form-item prop="check_true_image" ref="check_true_image" style="margin-bottom: 20px">
                      <el-input :disabled="form.check_true.includes('3') == false" style="margin: 6px 0 0px 0"
                        v-model="form.check_true_image" placeholder="请输入影像学检查结果" type="textarea" />
                    </el-form-item>
                  </div>

                  <div class="check-box-true-flex">
                    <el-checkbox label="4" name="type" @change="check_true_pathologyClick">病理检查结果：</el-checkbox>
                    <el-form-item prop="check_true_pathology" ref="check_true_pathology" style="margin-bottom: 20px">
                      <el-input :disabled="form.check_true.includes('4') == false" style="margin: 6px 0 0px 0"
                        v-model="form.check_true_pathology" placeholder="请输入病理检查结果" type="textarea" />
                    </el-form-item>
                  </div>

                  <div class="check-box-true-flex">
                    <el-checkbox label="5" name="type" @change="check_true_otherClick">其他检查结果：</el-checkbox>
                    <el-form-item prop="check_true_other" ref="check_true_other" style="margin-bottom: 20px">
                      <el-input :disabled="form.check_true.includes('5') == false" style="margin-top: 6px"
                        v-model="form.check_true_other" placeholder="请输入其他检查结果" type="textarea" />
                    </el-form-item>
                  </div>
                </el-checkbox-group>
              </div>
              <div class="inform-box-jiancha" v-if="form.check == 2">
                <div class="inform-box-jiancha-title" style="margin-bottom: 15px">
                  未进行检查原因：
                </div>
                <el-form-item prop="check_false" ref="check_false" style="margin-bottom: 0">
                  <el-checkbox-group v-model="form.check_false">
                    <el-checkbox label="3" name="type" style="margin-bottom: 0px">
                      担心费用问题
                    </el-checkbox>
                    <el-checkbox label="4" name="type" style="margin-bottom: 0px">
                      没有出现明显症状
                    </el-checkbox>
                    <el-checkbox label="5" name="type" style="margin-bottom: 0px">
                      工作忙，没有时间检查
                    </el-checkbox>
                    <el-checkbox label="1" name="type" style="margin-bottom: 0px">
                      不知晓
                    </el-checkbox>
                    <el-checkbox label="2" name="type">不重视</el-checkbox>
                    <el-checkbox label="6" name="type">其他</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item v-if="form.check_false.includes('6') == true" prop="check_false_input"
                  ref="check_false_input" style="margin-bottom: 0">
                  <el-input class="form-input-xia" v-model="form.check_false_input" placeholder="请输入内容" style="
                                left: 52%;
                                top: -35px;
                                width: 140px;
                                margin-bottom: 0;
                              "></el-input>
                </el-form-item>
              </div>
            </div>
            <!-- 既往治疗 -->
            <div class="inform-box" style="margin-top: 10px">
              <el-form-item label="既往治疗：" prop="treatment" ref="treatment" style="margin: 8px 0 0 0">
                <el-radio-group v-model="form.treatment">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="inform-box-jiancha" v-if="form.treatment == 1">
                <el-form-item prop="treatment_date" ref="treatment_date" style="margin-bottom: 10px">
                  <div style="
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                              ">
                    <div style="color: #606266">治疗时间：</div>
                    <el-date-picker type="date" placeholder="选择日期" v-model="form.treatment_date"></el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item prop="treatment_specific" ref="treatment_specific" style="margin-bottom: 10px">
                  <div style="color: #606266">具体治疗方案：</div>
                  <el-input v-model="form.treatment_specific" placeholder="请输入具体治疗方案" type="textarea" />
                </el-form-item>
                <el-form-item prop="treatment_effect" ref="treatment_effect" style="margin-bottom: 0">
                  <div style="color: #606266">治疗效果如何：</div>
                  <el-input v-model="form.treatment_effect" placeholder="请输入治疗效果" type="textarea" />
                </el-form-item>

                <el-form-item prop="treatment_return_visit" ref="treatment_return_visit" style="margin-bottom: 10px">
                  <div style="display: flex; align-items: center">
                    <div style="color: #606266; margin-top: 18px">
                      是否回访：
                    </div>
                    <el-radio-group v-model="form.treatment_return_visit">
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
              </div>
              <div v-if="form.treatment == 2" class="inform-box-jiancha" style="padding-top: 0">
                <el-form-item prop="treatment_untreated" ref="treatment_untreated" style="margin-bottom: 0">
                  <div style="color: #606266">未治疗原因：</div>
                  <el-input v-model="form.treatment_untreated" placeholder="请输入未治疗原因" type="textarea" />
                </el-form-item>
              </div>
            </div>
            <!-- <div class="down-btn" @click="down1">下一页</div> -->
          </div>
          <!-- 临床检查 v-show="informShow2" -->
          <div style="margin-top: 20px" ref="checkref">
            <div class="index-title">
              <div class="index-title-img">
                <img src="@/assets/image/questionnaire/组 756@2x.png" />
              </div>
              <div class="index-title-name">临床检查</div>
              <div class="index-title-xia" style="width: 65px"></div>
            </div>
            <!-- 消化疾病相关检查 -->
            <div class="inform-box">
              <div style="margin-bottom: 15px; color: #606266">
                消化疾病相关检查：
              </div>
              <el-checkbox-group v-model="form.digestive_diseases">
                <el-checkbox label="1" name="type" style="margin-bottom: 8px">体格检查</el-checkbox>
                <div class="check-box-true-flex">
                  <el-checkbox label="2" name="type" @change="digestive_diseases_laboratoryClick">实验室检查结果：</el-checkbox>
                  <el-form-item prop="digestive_diseases_laboratory" ref="digestive_diseases_laboratory"
                    style="margin-bottom: 20px">
                    <el-input :disabled="form.digestive_diseases.includes('2') == false" style="margin: 6px 0 0px 0"
                      v-model="form.digestive_diseases_laboratory" placeholder="请输入实验室检查结果" type="textarea" />
                  </el-form-item>
                </div>
                <div class="check-box-true-flex">
                  <el-checkbox label="3" name="type" @change="digestive_diseases_imageClick">影像学检查结果：</el-checkbox>
                  <el-form-item prop="digestive_diseases_image" ref="digestive_diseases_image"
                    style="margin-bottom: 20px">
                    <el-input :disabled="form.digestive_diseases.includes('3') == false" style="margin: 6px 0 0px 0"
                      v-model="form.digestive_diseases_image" placeholder="请输入影像学检查结果" type="textarea" />
                  </el-form-item>
                </div>

                <div class="check-box-true-flex">
                  <el-checkbox label="4" name="type" @change="digestive_diseases_pathologyClick">病理检查结果：</el-checkbox>
                  <el-form-item prop="digestive_diseases_pathology" ref="digestive_diseases_pathology"
                    style="margin-bottom: 20px">
                    <el-input :disabled="form.digestive_diseases.includes('4') == false" style="margin: 6px 0 0px 0"
                      v-model="form.digestive_diseases_pathology" placeholder="请输入病理检查结果" type="textarea" />
                  </el-form-item>
                </div>

                <div class="check-box-true-flex">
                  <el-checkbox label="5" name="type" @change="digestive_diseases_otherClick">其他检查结果：</el-checkbox>
                  <el-form-item prop="digestive_diseases_other" ref="digestive_diseases_other"
                    style="margin-bottom: 20px">
                    <el-input :disabled="form.digestive_diseases.includes('5') == false" style="margin-top: 6px"
                      v-model="form.digestive_diseases_other" placeholder="请输入其他检查结果" type="textarea" />
                  </el-form-item>
                </div>
              </el-checkbox-group>
            </div>
            <!-- 幽门螺杆菌感染 -->
            <div class="inform-box" style="margin-top: 10px">
              <el-form-item label="幽门螺杆菌感染：" ref="helicobacter_pylori" style="margin-bottom: 0">
                <!-- prop="helicobacter_pylori" -->
                <el-radio-group v-model="form.helicobacter_pylori">
                  <el-radio :label="1">阳性</el-radio>
                  <el-radio :label="2">阴性</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <!-- 合并症相关检查 -->
            <div class="inform-box" style="margin-top: 10px">
              <div style="margin-bottom: 15px; color: #606266">
                合并症相关检查：
              </div>
              <el-checkbox-group v-model="form.comorbidities">
                <div class="check-box-true-flex">
                  <el-checkbox label="1" name="type" @change="comorbidities_anxietyClick">
                    焦虑(汉密尔顿焦虑量表评分)：
                  </el-checkbox>
                  <el-form-item prop="comorbidities_anxiety" ref="comorbidities_anxiety" style="margin-bottom: 20px">
                    <el-input :disabled="form.comorbidities.includes('1') == false" style="margin: 6px 0 0px 0"
                      v-model="form.comorbidities_anxiety" placeholder="请输入焦虑(汉密尔顿焦虑量表评分)" type="textarea" />
                  </el-form-item>
                </div>
                <div class="check-box-true-flex">
                  <el-checkbox label="2" name="type" @change="comorbidities_depressionClick">
                    抑郁(汉密尔顿抑郁量表评分)：
                  </el-checkbox>
                  <el-form-item prop="comorbidities_depression" ref="comorbidities_depression"
                    style="margin-bottom: 20px">
                    <el-input :disabled="form.comorbidities.includes('2') == false" style="margin: 6px 0 0px 0"
                      v-model="form.comorbidities_depression" placeholder="请输入抑郁(汉密尔顿抑郁量表评分)" type="textarea" />
                  </el-form-item>
                </div>

                <div class="check-box-true-flex">
                  <el-checkbox label="3" name="type" @change="comorbidities_otherClick">其他：</el-checkbox>
                  <el-form-item prop="comorbidities_other" ref="comorbidities_other" style="margin-bottom: 20px">
                    <el-input :disabled="form.comorbidities.includes('3') == false" style="margin-top: 6px"
                      v-model="form.comorbidities_other" placeholder="请输入其他" type="textarea" /></el-form-item>
                </div>
              </el-checkbox-group>
            </div>
            <!-- <div class="down-btn" @click="down2">下一页</div>
            <div class="up-btn" @click="up1">上一页</div> -->
          </div>
          <!-- 疾病诊断 v-show="informShow3" -->
          <div style="margin-top: 20px" ref="diagnosisref">
            <div class="index-title">
              <div class="index-title-img">
                <img src="@/assets/image/questionnaire/组 768@2x.png" />
              </div>
              <div class="index-title-name">疾病诊断</div>
              <div class="index-title-xia" style="width: 65px"></div>
            </div>
            <!-- 是否进行鉴别诊断 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item label="是否进行鉴别诊断:" ref="disease_identify" style="margin: 8px 0 0 0">
                <!-- prop="disease_identify" -->
                <el-radio-group v-model="form.disease_identify">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="inform-box-form-item">
                <div class="inform-box-jiancha" v-if="form.disease_identify == 1">
                  <el-form-item label="与那些疾病进行鉴别诊断：" prop="disease_identify_true" ref="disease_identify_true"
                    style="margin-bottom: 0">
                    <el-input v-model="form.disease_identify_true" placeholder="请输入与那些疾病进行鉴别诊断" type="textarea" />
                  </el-form-item>
                </div>
                <div class="inform-box-jiancha" v-if="form.disease_identify == 2">
                  <el-form-item label="原因：" prop="disease_identify_false" ref="disease_identify_false"
                    style="margin-bottom: 0">
                    <el-input v-model="form.disease_identify_false" placeholder="原因" type="textarea" />
                  </el-form-item>
                </div>
              </div>
            </div>
            <!-- 具体分类、分级/分期 -->
            <div class="inform-box" style="margin-top: 10px; padding-top: 0px">
              <el-form-item label="具体分类、分级/分期：" style="margin: 8px 0 0 0; padding-top: 4px" class="inform-box-lable">
                <el-input v-model="form.disease_classification" placeholder="请输入具体分类、分级/分期" type="textarea" />
              </el-form-item>
            </div>
            <!-- 合并病症 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item label="合并病症：" style="margin: 8px 0 0 0">
                <el-radio-group v-model="form.disease_comorbidities">
                  <el-radio :label="1">无</el-radio>
                  <el-radio :label="2" style="margin-right: 100px">
                    焦虑抑郁症
                  </el-radio>
                  <el-radio :label="3">其他</el-radio>
                </el-radio-group>
                <el-form-item v-if="form.disease_comorbidities == 3" prop="disease_comorbidities_input"
                  ref="disease_comorbidities_input">
                  <el-input class="form-input-xia" v-model="form.disease_comorbidities_input" placeholder="请输入内容"
                    style="left: 20%"></el-input>
                </el-form-item>
              </el-form-item>
            </div>
            <!-- 诊断 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item prop="disease_diagnosis" ref="disease_diagnosis" label="诊断：" style="margin: 8px 0 0 0">
                <el-checkbox-group v-model="form.disease_diagnosis" style="margin-top: 15px">
                  <el-checkbox label="1" name="type">慢性胃炎</el-checkbox>
                  <el-checkbox label="2" name="type">消化性溃疡</el-checkbox>
                  <el-checkbox label="3" name="type" style="padding-right: 150px">
                    功能性消化不良
                  </el-checkbox>
                  <el-checkbox label="4" name="type">其他</el-checkbox>
                </el-checkbox-group>
                <el-form-item prop="disease_diagnosis_input" ref="disease_diagnosis_input"
                  v-if="form.disease_diagnosis.includes('4') == true">
                  <el-input class="form-input-xia" v-model="form.disease_diagnosis_input" placeholder="请输入内容"
                    style="left: 20%; top: -36px"></el-input>
                </el-form-item>
              </el-form-item>
            </div>

            <!-- 中医证型 -->
            <div class="inform-box inform-box-input" style="margin-top: 10px">
              <el-form-item label="中医证型：" style="margin: 8px 0 0 0">
                <el-checkbox-group v-model="form.tcm_syndrome_type" style="margin-top: 15px">
                  <el-checkbox label="1" name="type">肝郁气滞证</el-checkbox>
                  <el-checkbox label="2" name="type">气滞型胃脘痛</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <!-- <div class="down-btn" @click="down3">下一页</div>
            <div class="up-btn" @click="up2">上一页</div> -->
          </div>
          <!-- 治疗方案 v-show="informShow4" -->
          <div style="margin-top: 20px" ref="treatmentref">
            <div class="index-title">
              <div class="index-title-img">
                <img src="@/assets/image/questionnaire/组 812@2x.png" />
              </div>
              <div class="index-title-name">治疗方案</div>
              <div class="index-title-xia" style="width: 65px"></div>
            </div>
            <div class="inform-box">
              <div class="inform-box-title">用药记录：</div>
              <!-- 用药方案 -->
              <el-form-item prop="treatment_plan" ref="treatment_plan" style="margin: 8px 0 0 0">
                <div style="display: flex; align-items: center">
                  <div class="inform-box-item-flex-name" style="width: 85px">
                    用药方案：
                  </div>
                  <el-radio-group v-model="form.treatment_plan" style="flex: 1;">
                    <el-radio :label="1" style="margin: 0 50px 15px 0;">胃苏颗粒</el-radio>
                    <el-radio :label="2" style="margin: 0 50px 15px 0px">胃苏颗粒+其它药物</el-radio>
                    <el-radio :label="3" style="margin: 0 50px 15px 0;">荜铃胃痛颗粒</el-radio>
                    <el-radio :label="4" style="margin: 0 0 10px 0">荜铃胃痛颗粒+其它药物</el-radio>
                  </el-radio-group>
                </div>
                <el-form-item style="position: relative; margin: 5px 0" v-if="form.treatment_plan == 2"
                  prop="treatment_plan_other" ref="treatment_plan_other">
                  <div>
                    <el-input class="form-input-xia" v-model="form.treatment_plan_other" placeholder="请输入内容"
                      style="width: 100%; left: 0"></el-input>
                    <div>（具体药物名称，剂量，使用周期）</div>
                  </div>
                </el-form-item>
                <el-form-item style="position: relative; margin: 5px 0" v-if="form.treatment_plan == 4"
                  prop="treatment_plan_other" ref="treatment_plan_other">
                  <div>
                    <el-input class="form-input-xia" v-model="form.treatment_plan_other" placeholder="请输入内容"
                      style="width: 100%; left: 0"></el-input>
                    <div>（具体药物名称，剂量，使用周期）</div>
                  </div>
                </el-form-item>
              </el-form-item>
              <!-- 用药起始时间 -->
              <el-form-item prop="treatment_plan_date" ref="treatment_plan_date" style="margin: 8px 0 0 0">
                <div class="inform-box-input" style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                            ">
                  <div class="inform-box-item-flex-name" style="width: 140px">
                    用药周期：
                  </div>
                  <div>
                    <el-input class="form-input-xia" v-model="form.treatment_plan_date" placeholder=""
                      style="width: 60px; left: 115px; top: 9px"></el-input>
                    <div style="position: absolute; top: 0px; right: 120px">
                      天
                    </div>
                  </div>
                  <!-- <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="form.treatment_plan_date"
                  ></el-date-picker> -->
                </div>
              </el-form-item>
              <!-- 治疗剂量 -->
              <el-form-item prop="treatment_mg" ref="treatment_mg" style="margin: 8px 0 0 0">
                <div class="inform-box-item-flex-name">治疗剂量：</div>
                <div class="inform-box-item-flex-shuang">
                  <div class="inform-box-item-flex-shuang-box">
                    <!-- <div style="width: 80px"></div> -->
                    <el-input style="width: 100px" class="form-input-xia" v-model="form.treatment_bag" />
                    <div>袋/次:</div>
                  </div>
                  <div class="inform-box-item-flex-shuang-box">
                    <div></div>
                    <el-input style="width: 100px" class="form-input-xia" v-model="form.treatment_mg" />
                    <div>次/天</div>
                  </div>
                </div>
              </el-form-item>
              <!-- 合并用药情况 -->
              <!-- <div>
                <el-form-item
                  label="合并用药情况："
                  prop="treatment_situation"
                  ref="treatment_situation"
                  style="margin: 30px 0 0 0"
                >
                  <el-radio-group v-model="form.treatment_situation">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="2">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="具体药物及剂量："
                  class="inform-box-lable"
                  prop="treatment_situation_input"
                  ref="treatment_situation_input"
                  style="margin: 5px 0 0 0"
                  v-if="form.treatment_situation == 1"
                >
                  <el-input
                    v-model="form.treatment_situation_input"
                    placeholder="请输入具体药物及剂量"
                    type="textarea"
                  />
                </el-form-item>
              </div> -->
              <!-- 治疗期间是否调整治疗药物剂量 -->
              <div>
                <el-form-item label="治疗期间是否调整治疗药物剂量：" prop="treatment_dose" ref="treatment_dose"
                  style="margin: 35px 0 0 0">
                  <el-radio-group v-model="form.treatment_dose">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="2">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="原因：" prop="treatment_dose_input" ref="treatment_dose_input" class="inform-box-lable"
                  style="margin: 5px 0 0 0" v-if="form.treatment_dose == 1">
                  <el-input v-model="form.treatment_dose_input" placeholder="请输入原因" type="textarea" />
                </el-form-item>
              </div>
            </div>
            <!-- <div class="down-btn" @click="down4">下一页</div>
            <div class="up-btn" @click="up3">上一页</div> -->
          </div>
          <!-- 疗效评估 v-show="informShow5"-->
          <div style="margin-top: 20px" ref="evaluateref">
            <div v-show="form.disease_diagnosis.length != 0">
              <div class="index-title">
                <div class="index-title-img">
                  <img src="@/assets/image/questionnaire/组 768@2x.png" />
                </div>
                <div class="index-title-name">疗效评估</div>
                <div class="index-title-xia" style="width: 65px"></div>
              </div>
              <div style="color: #e62626; margin-bottom: 20px">
                （注：慢性胃炎、消化性溃疡、功能性消化不良、其他，四类至少填写一类，每类至少填写2项）
              </div>
              <!-- 慢性胃炎疗效评估 -->
              <div class="inform-box" v-if="form.disease_diagnosis.includes('1') == true">
                <el-form-item prop="gastritis" ref="gastritis" style="margin-top: 10px; margin-bottom: 0">
                  <div class="ping-box">
                    <div class="ping-box-img">
                      <img src="@/assets/image/questionnaire/1.png" />
                    </div>
                    <div style="color: #e62626">（至少填写2项）</div>
                  </div>
                  <div class="ping-xiang">
                    评估项目：
                    <span style="color: #ec6f40"> 临床症状（症状积分） </span>
                  </div>
                  <div>结果：</div>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <el-input v-model="form.gastritis_clinical" placeholder="请输入临床症状（症状积分）" type="textarea" />
                  </el-form-item>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <div class="ping-xiang">
                      评估项目：
                      <span style="color: #ec6f40">
                        实验室指标（如炎性因子、胃肠激素等）、Hp根除率等
                      </span>
                    </div>
                    <div>结果：</div>
                    <el-input v-model="form.gastritis_laboratory" placeholder="请输入实验室指标（如炎性因子、胃肠激素等）、Hp根除率等"
                      type="textarea" />
                  </el-form-item>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <div class="ping-xiang">
                      评估项目：
                      <span style="color: #ec6f40">疗效评价</span>
                    </div>
                    <div>结果：</div>
                    <el-input v-model="form.gastritis_curativeeffect" placeholder="请输入疗效评价" type="textarea" />
                  </el-form-item>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <div class="ping-xiang">
                      评估项目：
                      <span style="color: #ec6f40">并发症等</span>
                    </div>
                    <div>结果：</div>
                    <el-input v-model="form.gastritis_complications" placeholder="请输入并发症等" type="textarea" />
                  </el-form-item>
                </el-form-item>
              </div>
              <!-- 消化性溃疡疗效评估  -->
              <div class="inform-box" style="margin-top: 10px" v-if="form.disease_diagnosis.includes('2') == true">
                <!--  v-if="form.disease_diagnosis.includes('2') == true" -->
                <el-form-item prop="ulcer" ref="ulcer" style="margin-top: 10px; margin-bottom: 0">
                  <div class="ping-box">
                    <div class="ping-box-img">
                      <img src="@/assets/image/questionnaire/2.png" />
                    </div>
                    <div style="color: #e62626">（至少填写2项）</div>
                  </div>
                  <div class="ping-xiang">
                    评估项目：
                    <span style="color: #ec6f40">临床症状（中医证候疗效评价标准）</span>
                  </div>
                  <div>结果：</div>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <el-input v-model="form.ulcer_clinical" placeholder="请输入临床症状（中医证候疗效评价标准）" type="textarea" />
                  </el-form-item>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <div class="ping-xiang">
                      评估项目：
                      <span style="color: #ec6f40">
                        疗效评价（溃疡愈合情况）
                      </span>
                    </div>
                    <div>结果：</div>
                    <el-input v-model="form.ulcer_evaluation" placeholder="请输入疗效评价（溃疡愈合情况）" type="textarea" />
                  </el-form-item>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <div class="ping-xiang">
                      评估项目：
                      <span style="color: #ec6f40">Hp根除率</span>
                    </div>
                    <div>结果：</div>
                    <el-input v-model="form.ulcer_hp" placeholder="请输入Hp根除率" type="textarea" />
                  </el-form-item>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <div class="ping-xiang">
                      评估项目：
                      <span style="color: #ec6f40">并发症等情况</span>
                    </div>
                    <div>结果：</div>
                    <el-input v-model="form.ulcer_complications" placeholder="请输入并发症等情况" type="textarea" />
                  </el-form-item>
                </el-form-item>
              </div>
              <!-- 功能性消化不良疗效评估  -->
              <div class="inform-box" style="margin-top: 10px" v-if="form.disease_diagnosis.includes('3') == true">
                <!--  v-if="form.disease_diagnosis.includes('2') == true" -->
                <el-form-item prop="dyspepsia" ref="dyspepsia" style="margin-bottom: 0">
                  <div class="ping-box">
                    <div class="ping-box-img">
                      <img src="@/assets/image/questionnaire/3.png" />
                    </div>
                    <div style="color: #e62626">（至少填写2项）</div>
                  </div>
                  <div class="ping-xiang">
                    评估项目：
                    <span style="color: #ec6f40">症状评价（症状积分）</span>
                  </div>
                  <div>结果：</div>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <el-input v-model="form.dyspepsia_evaluation" placeholder="请输入症状评价（症状积分）" type="textarea" />
                  </el-form-item>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <div class="ping-xiang">
                      评估项目：
                      <span style="color: #ec6f40">
                        胃功能评估（GE或LNLT检查）
                      </span>
                    </div>
                    <div>结果：</div>
                    <el-input v-model="form.dyspepsia_evaluate" placeholder="请输入胃功能评估（GE或LNLT检查）" type="textarea" />
                  </el-form-item>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <div class="ping-xiang">
                      评估项目：
                      <span style="color: #ec6f40">生活质量评估（FDDQL或SF-NDI量表）</span>
                    </div>
                    <div>结果：</div>
                    <el-input v-model="form.dyspepsia_quality" placeholder="请输入生活质量评估（FDDQL或SF-NDI量表）" type="textarea" />
                  </el-form-item>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <div class="ping-xiang">
                      评估项目：
                      <span style="color: #ec6f40">其他疗效评估</span>
                    </div>
                    <div>结果：</div>
                    <el-input v-model="form.ulcer_other" placeholder="请输入其他疗效评估" type="textarea" />
                  </el-form-item>
                </el-form-item>
              </div>
              <!-- 其他疾病疗效评估  -->
              <div class="inform-box" style="margin-top: 10px" v-if="form.disease_diagnosis.includes('4') == true">
                <!--  v-if="form.disease_diagnosis.includes('2') == true" -->
                <el-form-item prop="otherdiseases" ref="otherdiseases" style="margin-top: 10px; margin-bottom: 0">
                  <div class="ping-box">
                    <div class="ping-box-img">
                      <img src="@/assets/image/questionnaire/4.png" />
                    </div>
                    <div style="color: #e62626">（至少填写2项）</div>
                  </div>
                  <div class="ping-xiang">
                    评估项目：
                    <span style="color: #ec6f40">临床症状</span>
                  </div>
                  <div>结果：</div>
                  <el-form-item style="margin-bottom: 10px" class="form-evaluate-con-right">
                    <el-input v-model="form.otherdiseases_clinical" placeholder="请输入临床症状" type="textarea" />
                  </el-form-item>
                  <el-form-item class="form-evaluate-con-right">
                    <div class="ping-xiang">
                      评估项目：
                      <span style="color: #ec6f40"> 其他指标评估 </span>
                    </div>
                    <div>结果：</div>
                    <el-input v-model="form.otherdiseases_other" placeholder="请输入其他指标评估" type="textarea" />
                  </el-form-item>
                </el-form-item>
              </div>
            </div>
            <!-- <div class="down-btn" @click="down5">下一页</div>
            <div class="up-btn" @click="up4">上一页</div> -->
          </div>
          <!-- 这里要放中医 -->
          <!-- 中医 -->
          <div style="margin-top: 20px" v-show="form.tcm_syndrome_type.length != 0">
            <div class="index-title" ref="zhongyiref">
              <div class="index-title-img">
                <img src="@/assets/image/questionnaire/zhonyi.png" />
              </div>
              <div class="index-title-name">中医症状评分表</div>
              <div class="index-title-xia" style="width: 107px"></div>
            </div>
            <!-- 前 -->
            <div class="inform-box" style="margin-bottom: 10px">
              <div class="zhongyi-head">治疗前症状程度评分</div>
              <div class="zhongyi-text">
                <div class="zhongyi-text-zhu">注：</div>
                <div class="zhongyi-text-name">
                  <div>0：无症状</div>
                  <div>1：轻度，稍加注意或经提示才意识到症状存在</div>
                  <div>2：中度，症状明显，但不影响工作和生活</div>
                  <div>3：严重，症状明显，影响工作及生活</div>
                  <div>4：极严重，症状很明显，严重影响工作及生活</div>
                </div>
              </div>
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">胸肋胀痛</div>
                <div class="zhongyi-box-slider">
                  <el-slider style="width: 225px" v-model="form.pre_degree_pain_chest_ribs" show-stops :min="0" :max="4"
                    :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style1" :class="
                    form.pre_degree_pain_chest_ribs == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.pre_degree_pain_chest_ribs }}
                  </div>
                  <div :style="style1" class="form-zhongyi-box-slider-cen-zheng">
                    <span class="zhong-zheng1" v-if="form.pre_degree_pain_chest_ribs == 0">
                      无症状
                    </span>
                    <span v-if="form.pre_degree_pain_chest_ribs == 1">
                      轻度
                    </span>
                    <span v-if="form.pre_degree_pain_chest_ribs == 2">
                      中度
                    </span>
                    <span v-if="form.pre_degree_pain_chest_ribs == 3">
                      严重
                    </span>
                    <span class="zhong-zheng5" v-if="form.pre_degree_pain_chest_ribs == 4">
                      极严重
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">脘腹痞满</div>
                <div class="zhongyi-box-slider">
                  <el-slider style="width: 225px" v-model="form.pre_degree_epigastric_full" show-stops :min="0" :max="4"
                    :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style2" :class="
                    form.pre_degree_epigastric_full == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.pre_degree_epigastric_full }}
                  </div>
                  <div :style="style2" class="form-zhongyi-box-slider-cen-zheng">
                    <span class="zhong-zheng1" v-if="form.pre_degree_epigastric_full == 0">
                      无症状
                    </span>
                    <span v-if="form.pre_degree_epigastric_full == 1">
                      轻度
                    </span>
                    <span v-if="form.pre_degree_epigastric_full == 2">
                      中度
                    </span>
                    <span v-if="form.pre_degree_epigastric_full == 3">
                      严重
                    </span>
                    <span class="zhong-zheng5" v-if="form.pre_degree_epigastric_full == 4">
                      极严重
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">心烦</div>
                <div class="zhongyi-box-slider">
                  <el-slider class="zhongyi-box-slider-item" v-model="form.pre_degree_be_upset" show-stops :min="0"
                    :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style3" :class="
                    form.pre_degree_be_upset == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.pre_degree_be_upset }}
                  </div>
                  <div :style="style3" class="form-zhongyi-box-slider-cen-zheng">
                    <span class="zhong-zheng1" v-if="form.pre_degree_be_upset == 0">
                      无症状
                    </span>
                    <span v-if="form.pre_degree_be_upset == 1"> 轻度 </span>
                    <span v-if="form.pre_degree_be_upset == 2"> 中度 </span>
                    <span v-if="form.pre_degree_be_upset == 3"> 严重 </span>
                    <span class="zhong-zheng5" v-if="form.pre_degree_be_upset == 4">
                      极严重
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">嗳气频做</div>
                <div class="zhongyi-box-slider">
                  <el-slider class="zhongyi-box-slider-item" v-model="form.pre_degree_eructation_frequent" show-stops
                    :min="0" :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style4" :class="
                    form.pre_degree_eructation_frequent == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.pre_degree_eructation_frequent }}
                  </div>
                  <div :style="style4" class="form-zhongyi-box-slider-cen-zheng">
                    <span class="zhong-zheng1" v-if="form.pre_degree_eructation_frequent == 0">
                      无症状
                    </span>
                    <span v-if="form.pre_degree_eructation_frequent == 1">
                      轻度
                    </span>
                    <span v-if="form.pre_degree_eructation_frequent == 2">
                      中度
                    </span>
                    <span v-if="form.pre_degree_eructation_frequent == 3">
                      严重
                    </span>
                    <span class="zhong-zheng5" v-if="form.pre_degree_eructation_frequent == 4">
                      极严重
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">善太息<br />频繁叹气</div>
                <div class="zhongyi-box-slider">
                  <el-slider class="zhongyi-box-slider-item" v-model="form.pre_degree_mild_breathing" show-stops :min="0"
                    :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style5" :class="
                    form.pre_degree_mild_breathing == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.pre_degree_mild_breathing }}
                  </div>
                  <div :style="style5" class="form-zhongyi-box-slider-cen-zheng">
                    <span class="zhong-zheng1" v-if="form.pre_degree_mild_breathing == 0">
                      无症状
                    </span>
                    <span v-if="form.pre_degree_mild_breathing == 1">
                      轻度
                    </span>
                    <span v-if="form.pre_degree_mild_breathing == 2">
                      中度
                    </span>
                    <span v-if="form.pre_degree_mild_breathing == 3">
                      严重
                    </span>
                    <span class="zhong-zheng5" v-if="form.pre_degree_mild_breathing == 4">
                      极严重
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
            </div>
            <!-- 后 -->
            <div class="inform-box" style="margin-bottom: 10px">
              <div class="zhongyi-head">治疗前症状频率评分</div>
              <div class="zhongyi-text">
                <div class="zhongyi-text-zhu">注：</div>
                <div class="zhongyi-text-name">
                  <div>0：无</div>
                  <div>1：1ｄ/周</div>
                  <div>2：2～3ｄ/周</div>
                  <div>3：4～5ｄ/周</div>
                  <div>4：持续</div>
                </div>
              </div>
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">胸肋胀痛</div>
                <div class="zhongyi-box-slider">
                  <el-slider style="width: 225px" v-model="form.pre_frequency_pain_chest_ribs" show-stops :min="0"
                    :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style6" :class="
                    form.pre_frequency_pain_chest_ribs == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.pre_frequency_pain_chest_ribs }}
                  </div>
                  <div :style="style6" class="form-zhongyi-box-slider-cen-zheng-hou">
                    <span class="zhong-zheng1-hou" v-if="form.pre_frequency_pain_chest_ribs == 0">
                      无
                    </span>
                    <span class="zhong-zheng2-hou" v-if="form.pre_frequency_pain_chest_ribs == 1">
                      1ｄ/周
                    </span>
                    <span class="zhong-zheng3-hou" v-if="form.pre_frequency_pain_chest_ribs == 2">
                      2～3ｄ/周
                    </span>
                    <span class="zhong-zheng4-hou" v-if="form.pre_frequency_pain_chest_ribs == 3">
                      4～5ｄ/周
                    </span>
                    <span class="zhong-zheng5-hou" v-if="form.pre_frequency_pain_chest_ribs == 4">
                      持续
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">脘腹痞满</div>
                <div class="zhongyi-box-slider">
                  <el-slider style="width: 225px" v-model="form.pre_frequency_epigastric_full" show-stops :min="0"
                    :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style7" :class="
                    form.pre_frequency_epigastric_full == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.pre_frequency_epigastric_full }}
                  </div>
                  <div :style="style7" class="form-zhongyi-box-slider-cen-zheng-hou">
                    <span class="zhong-zheng1-hou" v-if="form.pre_frequency_epigastric_full == 0">
                      无
                    </span>
                    <span class="zhong-zheng2-hou" v-if="form.pre_frequency_epigastric_full == 1">
                      1ｄ/周
                    </span>
                    <span class="zhong-zheng3-hou" v-if="form.pre_frequency_epigastric_full == 2">
                      2～3ｄ/周
                    </span>
                    <span class="zhong-zheng4-hou" v-if="form.pre_frequency_epigastric_full == 3">
                      4～5ｄ/周
                    </span>
                    <span class="zhong-zheng5-hou" v-if="form.pre_frequency_epigastric_full == 4">
                      持续
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">心烦</div>
                <div class="zhongyi-box-slider">
                  <el-slider class="zhongyi-box-slider-item" v-model="form.pre_frequency_be_upset" show-stops :min="0"
                    :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style8" :class="
                    form.pre_frequency_be_upset == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.pre_frequency_be_upset }}
                  </div>
                  <div :style="style8" class="form-zhongyi-box-slider-cen-zheng-hou">
                    <span class="zhong-zheng1-hou" v-if="form.pre_frequency_be_upset == 0">
                      无
                    </span>
                    <span class="zhong-zheng2-hou" v-if="form.pre_frequency_be_upset == 1">
                      1ｄ/周
                    </span>
                    <span class="zhong-zheng3-hou" v-if="form.pre_frequency_be_upset == 2">
                      2～3ｄ/周
                    </span>
                    <span class="zhong-zheng4-hou" v-if="form.pre_frequency_be_upset == 3">
                      4～5ｄ/周
                    </span>
                    <span class="zhong-zheng5-hou" v-if="form.pre_frequency_be_upset == 4">
                      持续
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">嗳气频做</div>
                <div class="zhongyi-box-slider">
                  <el-slider class="zhongyi-box-slider-item" v-model="form.pre_frequency_eructation_frequent" show-stops
                    :min="0" :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style9" :class="
                    form.pre_frequency_eructation_frequent == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.pre_frequency_eructation_frequent }}
                  </div>
                  <div :style="style9" class="form-zhongyi-box-slider-cen-zheng-hou">
                    <span class="zhong-zheng1-hou" v-if="form.pre_frequency_eructation_frequent == 0">
                      无
                    </span>
                    <span class="zhong-zheng2-hou" v-if="form.pre_frequency_eructation_frequent == 1">
                      1ｄ/周
                    </span>
                    <span class="zhong-zheng3-hou" v-if="form.pre_frequency_eructation_frequent == 2">
                      2～3ｄ/周
                    </span>
                    <span class="zhong-zheng4-hou" v-if="form.pre_frequency_eructation_frequent == 3">
                      4～5ｄ/周
                    </span>
                    <span class="zhong-zheng5-hou" v-if="form.pre_frequency_eructation_frequent == 4">
                      持续
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">善太息<br />频繁叹气</div>
                <div class="zhongyi-box-slider">
                  <el-slider class="zhongyi-box-slider-item" v-model="form.pre_frequency_mild_breathing" show-stops
                    :min="0" :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style10" :class="
                    form.pre_frequency_mild_breathing == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.pre_frequency_mild_breathing }}
                  </div>
                  <div :style="style10" class="form-zhongyi-box-slider-cen-zheng-hou">
                    <span class="zhong-zheng1-hou" v-if="form.pre_frequency_mild_breathing == 0">
                      无
                    </span>
                    <span class="zhong-zheng2-hou" v-if="form.pre_frequency_mild_breathing == 1">
                      1ｄ/周
                    </span>
                    <span class="zhong-zheng3-hou" v-if="form.pre_frequency_mild_breathing == 2">
                      2～3ｄ/周
                    </span>
                    <span class="zhong-zheng4-hou" v-if="form.pre_frequency_mild_breathing == 3">
                      4～5ｄ/周
                    </span>
                    <span class="zhong-zheng5-hou" v-if="form.pre_frequency_mild_breathing == 4">
                      持续
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
            </div>
            <!-- 前 -->
            <div class="inform-box" style="margin-bottom: 10px">
              <div class="zhongyi-head">治疗后症状程度评分</div>
              <div class="zhongyi-text">
                <div class="zhongyi-text-zhu">注：</div>
                <div class="zhongyi-text-name">
                  <div>0：无症状</div>
                  <div>1：轻度，稍加注意或经提示才意识到症状存在</div>
                  <div>2：中度，症状明显，但不影响工作和生活</div>
                  <div>3：严重，症状明显，影响工作及生活</div>
                  <div>4：极严重，症状很明显，严重影响工作及生活</div>
                </div>
              </div>
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">胸肋胀痛</div>
                <div class="zhongyi-box-slider">
                  <el-slider style="width: 225px" v-model="form.post_degree_pain_chest_ribs" show-stops :min="0" :max="4"
                    :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style11" :class="
                    form.post_degree_pain_chest_ribs == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.post_degree_pain_chest_ribs }}
                  </div>
                  <div :style="style11" class="form-zhongyi-box-slider-cen-zheng">
                    <span class="zhong-zheng1" v-if="form.post_degree_pain_chest_ribs == 0">
                      无症状
                    </span>
                    <span v-if="form.post_degree_pain_chest_ribs == 1">
                      轻度
                    </span>
                    <span v-if="form.post_degree_pain_chest_ribs == 2">
                      中度
                    </span>
                    <span v-if="form.post_degree_pain_chest_ribs == 3">
                      严重
                    </span>
                    <span class="zhong-zheng5" v-if="form.post_degree_pain_chest_ribs == 4">
                      极严重
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">脘腹痞满</div>
                <div class="zhongyi-box-slider">
                  <el-slider style="width: 225px" v-model="form.post_degree_epigastric_full" show-stops :min="0" :max="4"
                    :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style12" :class="
                    form.post_degree_epigastric_full == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.post_degree_epigastric_full }}
                  </div>
                  <div :style="style12" class="form-zhongyi-box-slider-cen-zheng">
                    <span class="zhong-zheng1" v-if="form.post_degree_epigastric_full == 0">
                      无症状
                    </span>
                    <span v-if="form.post_degree_epigastric_full == 1">
                      轻度
                    </span>
                    <span v-if="form.post_degree_epigastric_full == 2">
                      中度
                    </span>
                    <span v-if="form.post_degree_epigastric_full == 3">
                      严重
                    </span>
                    <span class="zhong-zheng5" v-if="form.post_degree_epigastric_full == 4">
                      极严重
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">心烦</div>
                <div class="zhongyi-box-slider">
                  <el-slider class="zhongyi-box-slider-item" v-model="form.post_degree_be_upset" show-stops :min="0"
                    :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style13" :class="
                    form.post_degree_be_upset == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.post_degree_be_upset }}
                  </div>
                  <div :style="style13" class="form-zhongyi-box-slider-cen-zheng">
                    <span class="zhong-zheng1" v-if="form.post_degree_be_upset == 0">
                      无症状
                    </span>
                    <span v-if="form.post_degree_be_upset == 1"> 轻度 </span>
                    <span v-if="form.post_degree_be_upset == 2"> 中度 </span>
                    <span v-if="form.post_degree_be_upset == 3"> 严重 </span>
                    <span class="zhong-zheng5" v-if="form.post_degree_be_upset == 4">
                      极严重
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">嗳气频做</div>
                <div class="zhongyi-box-slider">
                  <el-slider class="zhongyi-box-slider-item" v-model="form.post_degree_eructation_frequent" show-stops
                    :min="0" :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style14" :class="
                    form.post_degree_eructation_frequent == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.post_degree_eructation_frequent }}
                  </div>
                  <div :style="style14" class="form-zhongyi-box-slider-cen-zheng">
                    <span class="zhong-zheng1" v-if="form.post_degree_eructation_frequent == 0">
                      无症状
                    </span>
                    <span v-if="form.post_degree_eructation_frequent == 1">
                      轻度
                    </span>
                    <span v-if="form.post_degree_eructation_frequent == 2">
                      中度
                    </span>
                    <span v-if="form.post_degree_eructation_frequent == 3">
                      严重
                    </span>
                    <span class="zhong-zheng5" v-if="form.post_degree_eructation_frequent == 4">
                      极严重
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">善太息<br />频繁叹气</div>
                <div class="zhongyi-box-slider">
                  <el-slider class="zhongyi-box-slider-item" v-model="form.post_degree_mild_breathing" show-stops :min="0"
                    :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style15" :class="
                    form.post_degree_mild_breathing == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.post_degree_mild_breathing }}
                  </div>
                  <div :style="style15" class="form-zhongyi-box-slider-cen-zheng">
                    <span class="zhong-zheng1" v-if="form.post_degree_mild_breathing == 0">
                      无症状
                    </span>
                    <span v-if="form.post_degree_mild_breathing == 1">
                      轻度
                    </span>
                    <span v-if="form.post_degree_mild_breathing == 2">
                      中度
                    </span>
                    <span v-if="form.post_degree_mild_breathing == 3">
                      严重
                    </span>
                    <span class="zhong-zheng5" v-if="form.post_degree_mild_breathing == 4">
                      极严重
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
            </div>
            <!-- 后 -->
            <div class="inform-box" style="margin-bottom: 10px">
              <div class="zhongyi-head">治疗后症状频率评分</div>
              <div class="zhongyi-text">
                <div class="zhongyi-text-zhu">注：</div>
                <div class="zhongyi-text-name">
                  <div>0：无</div>
                  <div>1：1ｄ/周</div>
                  <div>2：2～3ｄ/周</div>
                  <div>3：4～5ｄ/周</div>
                  <div>4：持续</div>
                </div>
              </div>
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">胸肋胀痛</div>
                <div class="zhongyi-box-slider">
                  <el-slider style="width: 225px" v-model="form.post_frequency_pain_chest_ribs" show-stops :min="0"
                    :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style16" :class="
                    form.post_frequency_pain_chest_ribs == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.post_frequency_pain_chest_ribs }}
                  </div>
                  <div :style="style16" class="form-zhongyi-box-slider-cen-zheng-hou">
                    <span class="zhong-zheng1-hou" v-if="form.post_frequency_pain_chest_ribs == 0">
                      无
                    </span>
                    <span class="zhong-zheng2-hou" v-if="form.post_frequency_pain_chest_ribs == 1">
                      1ｄ/周
                    </span>
                    <span class="zhong-zheng3-hou" v-if="form.post_frequency_pain_chest_ribs == 2">
                      2～3ｄ/周
                    </span>
                    <span class="zhong-zheng4-hou" v-if="form.post_frequency_pain_chest_ribs == 3">
                      4～5ｄ/周
                    </span>
                    <span class="zhong-zheng5-hou" v-if="form.post_frequency_pain_chest_ribs == 4">
                      持续
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">脘腹痞满</div>
                <div class="zhongyi-box-slider">
                  <el-slider style="width: 225px" v-model="form.post_frequency_epigastric_full" show-stops :min="0"
                    :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style17" :class="
                    form.post_frequency_epigastric_full == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.post_frequency_epigastric_full }}
                  </div>
                  <div :style="style17" class="form-zhongyi-box-slider-cen-zheng-hou">
                    <span class="zhong-zheng1-hou" v-if="form.post_frequency_epigastric_full == 0">
                      无
                    </span>
                    <span class="zhong-zheng2-hou" v-if="form.post_frequency_epigastric_full == 1">
                      1ｄ/周
                    </span>
                    <span class="zhong-zheng3-hou" v-if="form.post_frequency_epigastric_full == 2">
                      2～3ｄ/周
                    </span>
                    <span class="zhong-zheng4-hou" v-if="form.post_frequency_epigastric_full == 3">
                      4～5ｄ/周
                    </span>
                    <span class="zhong-zheng5-hou" v-if="form.post_frequency_epigastric_full == 4">
                      持续
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">心烦</div>
                <div class="zhongyi-box-slider">
                  <el-slider class="zhongyi-box-slider-item" v-model="form.post_frequency_be_upset" show-stops :min="0"
                    :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style18" :class="
                    form.post_frequency_be_upset == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.post_frequency_be_upset }}
                  </div>
                  <div :style="style18" class="form-zhongyi-box-slider-cen-zheng-hou">
                    <span class="zhong-zheng1-hou" v-if="form.post_frequency_be_upset == 0">
                      无
                    </span>
                    <span class="zhong-zheng2-hou" v-if="form.post_frequency_be_upset == 1">
                      1ｄ/周
                    </span>
                    <span class="zhong-zheng3-hou" v-if="form.post_frequency_be_upset == 2">
                      2～3ｄ/周
                    </span>
                    <span class="zhong-zheng4-hou" v-if="form.post_frequency_be_upset == 3">
                      4～5ｄ/周
                    </span>
                    <span class="zhong-zheng5-hou" v-if="form.post_frequency_be_upset == 4">
                      持续
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">嗳气频做</div>
                <div class="zhongyi-box-slider">
                  <el-slider class="zhongyi-box-slider-item" v-model="form.post_frequency_eructation_frequent" show-stops
                    :min="0" :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style19" :class="
                    form.post_frequency_eructation_frequent == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.post_frequency_eructation_frequent }}
                  </div>
                  <div :style="style19" class="form-zhongyi-box-slider-cen-zheng-hou">
                    <span class="zhong-zheng1-hou" v-if="form.post_frequency_eructation_frequent == 0">
                      无
                    </span>
                    <span class="zhong-zheng2-hou" v-if="form.post_frequency_eructation_frequent == 1">
                      1ｄ/周
                    </span>
                    <span class="zhong-zheng3-hou" v-if="form.post_frequency_eructation_frequent == 2">
                      2～3ｄ/周
                    </span>
                    <span class="zhong-zheng4-hou" v-if="form.post_frequency_eructation_frequent == 3">
                      4～5ｄ/周
                    </span>
                    <span class="zhong-zheng5-hou" v-if="form.post_frequency_eructation_frequent == 4">
                      持续
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
              <!-- 滑块 -->
              <div class="zhongyi-box">
                <div class="zhongyi-box-head">善太息<br />频繁叹气</div>
                <div class="zhongyi-box-slider">
                  <el-slider class="zhongyi-box-slider-item" v-model="form.post_frequency_mild_breathing" show-stops
                    :min="0" :max="4" :marks="{ 0: '', 1: '', 2: '', 3: '', 4: '' }" :show-tooltip="false">
                  </el-slider>
                  <div :style="style20" :class="
                    form.post_frequency_mild_breathing == 1
                      ? 'form-zhongyi-box-slider-cen-name1'
                      : 'form-zhongyi-box-slider-cen-name'
                  ">
                    {{ form.post_frequency_mild_breathing }}
                  </div>
                  <div :style="style20" class="form-zhongyi-box-slider-cen-zheng-hou">
                    <span class="zhong-zheng1-hou" v-if="form.post_frequency_mild_breathing == 0">
                      无
                    </span>
                    <span class="zhong-zheng2-hou" v-if="form.post_frequency_mild_breathing == 1">
                      1ｄ/周
                    </span>
                    <span class="zhong-zheng3-hou" v-if="form.post_frequency_mild_breathing == 2">
                      2～3ｄ/周
                    </span>
                    <span class="zhong-zheng4-hou" v-if="form.post_frequency_mild_breathing == 3">
                      4～5ｄ/周
                    </span>
                    <span class="zhong-zheng5-hou" v-if="form.post_frequency_mild_breathing == 4">
                      持续
                    </span>
                  </div>
                </div>
              </div>
              <!-- 滑块 -->
            </div>
          </div>
          <!-- 中医 -->
          <!-- 不良反应检测 v-show="informShow6" -->
          <div style="margin-top: 20px" ref="adversereactionref">
            <div class="index-title">
              <div class="index-title-img">
                <img src="@/assets/image/questionnaire/组 815@2x.png" />
              </div>
              <div class="index-title-name">不良反应检测</div>
              <div class="index-title-xia" style="width: 95px"></div>
            </div>
            <!-- 患者是否产生不良反应 -->
            <div class="inform-box" style="margin-top: 10px">
              <el-form-item label="患者是否产生不良反应：" style="margin: 8px 0 0 0" prop="adversereaction" ref="adversereaction">
                <el-radio-group v-model="form.adversereaction">
                  <el-radio :label="1">无</el-radio>
                  <el-radio :label="2">有</el-radio>
                </el-radio-group>
              </el-form-item>
              <div v-if="form.adversereaction == 2">
                <!-- 不良反应表现 -->
                <div class="inform-box-buliang inform-box-xiahuaxian" style="padding-bottom: 0px">
                  <el-form-item label="不良反应表现：" style="margin: 8px 0 0 0" prop="adversereaction_group"
                    ref="adversereaction_group">
                    <el-checkbox-group v-model="form.adversereaction_group" style="margin-top: 10px" class="buliang">
                      <el-checkbox label="1" name="type">头痛</el-checkbox>
                      <el-checkbox label="2" name="type">头晕</el-checkbox>
                      <el-checkbox label="3" name="type">恶心</el-checkbox>
                      <el-checkbox label="4" name="type">呕吐</el-checkbox>
                      <el-checkbox label="5" name="type">腹泻</el-checkbox>
                      <el-checkbox label="6" name="type">肌痛</el-checkbox>
                      <el-checkbox label="8" name="type">骨痛</el-checkbox>
                      <el-checkbox label="9" name="type">背痛</el-checkbox>
                      <el-checkbox label="10" name="type">寒颤</el-checkbox>
                      <el-checkbox label="11" name="type">疲劳</el-checkbox>
                      <el-checkbox label="12" name="type">乏力</el-checkbox>
                      <el-checkbox label="13" name="type">疼痛</el-checkbox>
                      <el-checkbox label="7" name="type">关节痛</el-checkbox>
                      <el-checkbox label="14" name="type">肢体疼痛</el-checkbox>
                      <el-checkbox label="15" name="type">流感样疾病</el-checkbox>
                      <el-checkbox label="16" name="type">其他</el-checkbox>
                    </el-checkbox-group>
                    <el-form-item prop="adversereaction_group_input" ref="adversereaction_group_input"
                      v-if="form.adversereaction_group.includes('16') == true">
                      <el-input class="form-input-xia" v-model="form.adversereaction_group_input" placeholder="请输入内容"
                        style="
                                    position: absolute;
                                    left: 65px;
                                    top: -35px;
                                    width: 160px;
                                  "></el-input>
                    </el-form-item>
                  </el-form-item>
                </div>
                <!-- 反应发生日期 -->
                <el-form-item prop="adversereaction_date" ref="adversereaction_date">
                  <div class="inform-box-buliang" style="
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                              ">
                    <div style="width: 110px; margin-left: 5px" class="form-xing">
                      反应发生日期：
                    </div>
                    <el-date-picker type="date" placeholder="选择日期" v-model="form.adversereaction_date"></el-date-picker>
                  </div>
                </el-form-item>
                <!-- 是否用药后立即发生： -->
                <div class="inform-box-buliang">
                  <el-form-item label="是否用药后立即发生：" style="margin: 8px 0 0 0" prop="adversereaction_immediately"
                    ref="adversereaction_immediately">
                    <el-radio-group v-model="form.adversereaction_immediately">
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <!-- 反应发生时间，用药后几小时： -->
                <div class="inform-box-buliang" style="padding-top: 5px">
                  <el-form-item label="反应发生时间，用药后几小时：" class="inform-box-lable" style="margin-bottom: 0"
                    prop="adversereaction_time_input" ref="adversereaction_time_input">
                    <el-input v-model="form.adversereaction_time_input" placeholder="请输入反应发生时间，用药后几小时" type="textarea" />
                  </el-form-item>
                </div>
                <!-- 不良反应的严重程度： -->
                <div class="inform-box-buliang">
                  <el-form-item label="不良反应的严重程度：" style="margin: 8px 0 0 0" prop="adversereaction_degree"
                    ref="adversereaction_degree">
                    <el-radio-group v-model="form.adversereaction_degree">
                      <el-radio :label="1">轻度</el-radio>
                      <el-radio :label="2">中度</el-radio>
                      <el-radio :label="3">重度</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <!-- 是否与观察药物相关： -->
                <div class="inform-box-buliang">
                  <el-form-item label="是否与观察药物相关：" style="margin: 8px 0 0 0" prop="adversereaction_related"
                    ref="adversereaction_related">
                    <el-radio-group v-model="form.adversereaction_related">
                      <el-radio :label="1">肯定</el-radio>
                      <el-radio :label="2">很可能</el-radio>
                      <el-radio :label="3">可能</el-radio>
                      <el-radio :label="4">可能无关</el-radio>
                      <el-radio :label="5">待评价</el-radio>
                      <el-radio :label="6">无法评价</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <!--不良反应的应对策略： -->
                <div class="inform-box-buliang" style="padding-top: 5px">
                  <el-form-item label="不良反应的应对策略：" class="inform-box-lable" style="margin-bottom: 0"
                    prop="adversereaction_strategy" ref="adversereaction_strategy">
                    <el-input v-model="form.adversereaction_strategy" placeholder="请输入不良反应的应对策略：" type="textarea" />
                  </el-form-item>
                </div>
              </div>
            </div>
            <!-- <div
              v-if="delShow"
              class="up-btn"
              @click="submitForm('form')"
              style="background-color: #7a75ff"
            >
              发布病例
            </div> -->
            <!-- <div class="up-btn" @click="up5">上一页</div>
            <div
              class="up-btn"
              style="background-color: #0ba29a"
              @click="down6"
            > 
              查看附件
            </div> -->
            <div class="inform-b-bgc">
              <img src="@/assets/image/questionnaire/组 863@2x.png" />
            </div>
            <!--  -->
          </div>
          <!-- 病例照片附件 -->
          <div style="margin-top: 20px" ref="uploadref">
            <div class="index-title">
              <div class="index-title-img">
                <img src="@/assets/image/questionnaire/组 815@2x.png" />
              </div>
              <div class="index-title-name">病例照片附件</div>
              <div class="index-title-xia" style="width: 95px"></div>
            </div>
            <el-form-item label="病例照片附件：" prop="attachments" class="inage-form-item">
              <div class="upload-demo">
                <el-upload :action="action" :on-remove="handleRemove" :before-remove="beforeRemove"
                  :on-success="handleAvatarSuccess" multiple :file-list="fileList" :before-upload="wenBeforeUpload"
                  :on-progress="onProgressTest" :data="uploadData">
                  <el-button size="small" type="primary" v-prevent="1500">点击上传</el-button>
                </el-upload>
              </div>
            </el-form-item>
            <!-- 图片 -->
            <div v-if="delShow" class="up-btn" @click="submitForm('form')" style="background-color: #7a75ff">
              发布病例
            </div>
          </div>
          <!-- 病例照片附件 -->
          <!-- 附件 v-show="informShow7" -->
          <div style="margin-top: 20px">
            <div class="fujian">
              <img src="@/assets/image/questionnaire/fujian.png" />
            </div>
            <!-- <div class="up-btn" @click="up6">上一页</div> -->
          </div>
          <!-- 结束 -->
        </div>
        <!-- 患者基本系 -->
      </el-form>
    </div>
    <!-- 邀请码 -->
    <van-dialog v-model="dialogShow" title="邀请码" :showCancelButton="true" :before-close="beforeClose"
      @confirm="confirmCode">
      <van-form ref="vanform">
        <van-field v-model="form.invitation_code" placeholder="请输入邀请码" :rules="[{ required: true, message: '请输入邀请码' }]" />
      </van-form>
    </van-dialog>
    <!-- 悬浮 -->
    <div class="xuan">
      <transition name="el-zoom-in-bottom">
        <div class="xuan-ul" v-show="showPopover">
          <div class="xuan-li" :class="index == tabsIndex ? 'xuan-li-active' : ''" v-for="(item, index) in tabsList"
            :key="index" @click="tabsClick(index)">
            <div>{{ item.top }}</div>
            <div>{{ item.bottom }}</div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="xuan-ru">
          <div class="xuan-ru-img" :class="{ anim: showPopover }" @click.stop="handleBtn()">
            <img src="@/assets/image/questionnaire/xuan.png" />
          </div>
        </div>
      </transition>
    </div>
    <!-- 悬浮 -->
  </div>
</template>
<script>
export default {
  name: "questionnaire",
  data() {
    //剂量
    var treatmentDose = (rule, value, callback) => {
      if (this.form.treatment_mg == "" || this.form.treatment_bag == "") {
        callback(new Error("请输入治疗剂量"));
      } else {
        callback();
      }
    };
    //胃炎
    var gastritisVerify = (rule, value, callback) => {
      let yi = this.form.gastritis_clinical;
      let er = this.form.gastritis_laboratory;
      let san = this.form.gastritis_curativeeffect;
      let si = this.form.gastritis_complications;
      if (
        (yi == "" || er == "") && //12
        (yi == "" || san == "") && //13
        (yi == "" || si == "") && //14
        (er == "" || san == "") && //23
        (er == "" || si == "") && //24
        (san == "" || si == "") //34
      ) {
        callback(new Error("至少填写2项"));
      } else {
        callback();
      }
    };
    //溃疡
    var ulcerVerify = (rule, value, callback) => {
      let yi = this.form.ulcer_clinical;
      let er = this.form.ulcer_evaluation;
      let san = this.form.ulcer_hp;
      let si = this.form.ulcer_complications;
      if (
        (yi == "" || er == "") && //12
        (yi == "" || san == "") && //13
        (yi == "" || si == "") && //14
        (er == "" || san == "") && //23
        (er == "" || si == "") && //24
        (san == "" || si == "") //34
      ) {
        callback(new Error("至少填写2项"));
      } else {
        callback();
      }
    };
    //消化不良
    var dyspepsiaVerify = (rule, value, callback) => {
      let yi = this.form.dyspepsia_evaluation;
      let er = this.form.dyspepsia_evaluate;
      let san = this.form.dyspepsia_quality;
      let si = this.form.ulcer_other;
      if (
        (yi == "" || er == "") && //12
        (yi == "" || san == "") && //13
        (yi == "" || si == "") && //14
        (er == "" || san == "") && //23
        (er == "" || si == "") && //24
        (san == "" || si == "") //34
      ) {
        callback(new Error("至少填写2项"));
      } else {
        callback();
      }
    };
    //其他疾病
    var otherdiseasesVerify = (rule, value, callback) => {
      let yi = this.form.otherdiseases_clinical;
      let er = this.form.otherdiseases_other;
      if (yi == "" || er == "") {
        callback(new Error("至少填写2项"));
      } else {
        callback();
      }
    };
    //既往检查
    var check_true_laboratoryVerify = (rule, value, callback) => {
      if (this.form.check_true.includes("2") == true) {
        if (this.form.check_true_laboratory == "") {
          callback(new Error("请输入实验室检查结果"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var check_true_imageVerify = (rule, value, callback) => {
      if (this.form.check_true.includes("3") == true) {
        if (this.form.check_true_image == "") {
          callback(new Error("请输入影像学检查结果"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var check_true_pathologyVerify = (rule, value, callback) => {
      if (this.form.check_true.includes("4") == true) {
        if (this.form.check_true_pathology == "") {
          callback(new Error("请输入病理检查结果"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var check_true_otherVerify = (rule, value, callback) => {
      if (this.form.check_true.includes("5") == true) {
        if (this.form.check_true_other == "") {
          callback(new Error("请输入其他检查结果"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    //消化疾病检查
    var digestive_diseases_laboratoryVerify = (rule, value, callback) => {
      if (this.form.digestive_diseases.includes("2") == true) {
        if (this.form.digestive_diseases_laboratory == "") {
          callback(new Error("请输入实验室检查结果"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var digestive_diseases_imageVerify = (rule, value, callback) => {
      if (this.form.digestive_diseases.includes("3") == true) {
        if (this.form.digestive_diseases_image == "") {
          callback(new Error("请输入影像学检查手段、结果"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var digestive_diseases_pathologyVerify = (rule, value, callback) => {
      if (this.form.digestive_diseases.includes("4") == true) {
        if (this.form.digestive_diseases_pathology == "") {
          callback(new Error("请输入病理检查手段。结果"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var digestive_diseases_otherVerify = (rule, value, callback) => {
      if (this.form.digestive_diseases.includes("5") == true) {
        if (this.form.digestive_diseases_other == "") {
          callback(new Error("请输入其他检查结果"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    //合并症相关检查
    var comorbidities_anxietyVerify = (rule, value, callback) => {
      if (this.form.comorbidities.includes("1") == true) {
        if (this.form.comorbidities_anxiety == "") {
          callback(new Error("焦虑(汉密尔顿焦虑量表评分)"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var comorbidities_depressionVerify = (rule, value, callback) => {
      if (this.form.comorbidities.includes("2") == true) {
        if (this.form.comorbidities_depression == "") {
          callback(new Error("抑郁(汉密尔顿抑郁量表评分)"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var comorbidities_otherVerify = (rule, value, callback) => {
      if (this.form.comorbidities.includes("3") == true) {
        if (this.form.comorbidities_other == "") {
          callback(new Error("请输入其他检查结果"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      action: `https://up-z1.qiniup.com`,
      fileList: [],
      uploadData: { key: "", token: "" },
      aaa: "",
      //年月日
      year: "",
      month: "",
      day: "",
      //----
      delShow: true,
      dialogShow: false,
      informShow1: true, //患者基本信息
      informShow2: false, //临床检查
      informShow3: false, //疾病诊断
      informShow4: false, //治疗方案
      informShow5: false, //疗效评估
      informShow6: false, //不良反应检测
      informShow7: false, //附件
      tabsIndex: 0,
      allOption: {},
      form: {
        id: "",
        act_id: "1",
        invitation_code: "",
        //基本信息
        name: "", //姓名
        age: "", //年级
        sex: "", //性别
        height: "", //身高
        weight: "", //体重
        source: "", //来源
        source_input: "", //来源其他
        bim: "", //bim
        bim_radio: "", //bim单选
        bim_input: "", //bim其他
        symptom: [], //症状
        symptom_input: "", //症状其他
        disease_code: "", //疾病状态
        course_disease: "", //病程
        drink_alcohol: "", //饮酒史
        drink_alcohol_quantity: "", //饮酒量
        drink_alcohol_frequency: "", //饮酒频率
        smoking_history: "", //吸烟史
        smoking_history_year: "", //吸烟史年
        smoking_history_quantity: "", //吸烟史根
        family_historyL: "", //家族史
        past_historyL: "", //既往史
        medical_history: "", //其他病史
        allergy: "", //过敏史
        allergy_input: "", //过敏史输入框
        check: "", //检查
        check_true: [], //检查 是
        check_true_laboratory: "", //实验室
        check_true_image: "", //影像学
        check_true_pathology: "", //病理
        check_true_other: "", //其他
        check_false: [], //检查否
        check_false_input: "", //检查否输入框
        treatment: "", //治疗
        treatment_date: "", //治疗时间
        treatment_specific: "", //具体治疗方案
        treatment_effect: "", //治疗效果
        treatment_return_visit: "", //回访
        treatment_untreated: "", //未治疗原因
        //临床检查
        digestive_diseases: [], //体格检查
        digestive_diseases_laboratory: "", //实验检查
        digestive_diseases_image: "", //影像检查
        digestive_diseases_pathology: "", //病理检查
        digestive_diseases_other: "", //其他检查
        helicobacter_pylori: "", //幽门螺杆菌
        comorbidities: [], //合并症
        comorbidities_anxiety: "", //焦虑
        comorbidities_depression: "", //抑郁
        comorbidities_other: "", //其他
        // 疾病诊断
        disease_identify: "", //是否进行鉴别诊断
        disease_identify_true: "", //是输入框
        disease_identify_false: "", //否输入框
        disease_diagnosis: [], //诊断
        disease_diagnosis_input: "", //诊断其他输入框
        disease_comorbidities: "", //合并病症
        disease_comorbidities_input: "", //合并病症其他
        disease_classification: "", //具体分类分级分期
        //治疗方案
        treatment_plan: "", //用药方案
        treatment_plan_other: "",
        treatment_plan_date: "", //用药时间
        treatment_mg: "", //剂量mg
        treatment_bag: "", //剂量 袋
        // treatment_situation: "", //合并用药情况
        // treatment_situation_input: "", //合并用药情况输入框
        treatment_dose: "", //药物剂量
        treatment_dose_input: "", //药物剂量输入框
        //疗效评估
        //胃炎
        gastritis_clinical: "", //临床症状
        gastritis_laboratory: "", //实验室指标
        gastritis_curativeeffect: "", //疗效评价
        gastritis_complications: "", //并发症等
        //溃疡
        ulcer_clinical: "", //临床
        ulcer_evaluation: "", //评价
        ulcer_hp: "", //hp
        ulcer_complications: "", //并发症
        //消化不良
        dyspepsia_evaluation: "",
        dyspepsia_evaluate: "",
        dyspepsia_quality: "",
        ulcer_other: "",
        //其他疾病
        otherdiseases_clinical: "", //临床
        otherdiseases_other: "", //其他指标
        //不良反应
        adversereaction: "", //是否产生不良反应
        adversereaction_group: [], //反应表现
        adversereaction_group_input: "", //反应表现其他
        adversereaction_date: "", //日期
        adversereaction_immediately: "", //立即发生
        adversereaction_time_input: "", //用药几小时
        adversereaction_degree: "", //不良反应的严重程度
        adversereaction_related: "", //药物相关
        adversereaction_strategy: "", //对策
        //中医
        tcm_syndrome_type: [], //中医证型
        pre_degree_pain_chest_ribs: 0, //治疗前程度-腹肋胀痛
        pre_degree_epigastric_full: 0, //治疗前程度-脘腹痞满
        pre_degree_be_upset: 0, //治疗前程度-心烦
        pre_degree_eructation_frequent: 0, //治疗前程度-嗳气频做
        pre_degree_mild_breathing: 0, //治疗前程度-善太息
        //
        pre_frequency_pain_chest_ribs: 0, // 治疗前频率-腹肋胀痛
        pre_frequency_epigastric_full: 0, //治疗前频率-脘腹痞满
        pre_frequency_be_upset: 0, //治疗前频率-心烦
        pre_frequency_eructation_frequent: 0, //治疗前频率-嗳气频做
        pre_frequency_mild_breathing: 0, //治疗前频率-善太息
        //
        post_degree_pain_chest_ribs: 0, //治疗后程度-腹肋胀痛
        post_degree_epigastric_full: 0, //治疗后程度-脘腹痞满
        post_degree_be_upset: 0, //治疗后程度-心烦
        post_degree_eructation_frequent: 0, //治疗后程度-嗳气频做
        post_degree_mild_breathing: 0, //治疗后程度-善太息
        //
        post_frequency_pain_chest_ribs: 0, //治疗后频率-腹肋胀痛
        post_frequency_epigastric_full: 0, //治疗后频率-脘腹痞满
        post_frequency_be_upset: 0, //治疗后频率-心烦
        post_frequency_eructation_frequent: 0, //治疗后频率-嗳气频做
        post_frequency_mild_breathing: 0, //治疗后频率-善太息
        //资料
        attachments: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        height: [{ required: true, message: "请输入身高", trigger: "blur" }],
        weight: [{ required: true, message: "请输入体重", trigger: "blur" }],
        source: [
          { required: true, message: "请选择病例来源", trigger: "change" },
        ],
        source_input: [
          { required: true, message: "请输入内容", trigger: "blur" },
        ],
        bim: [{ required: true, message: "请输入BMI", trigger: "blur" }],
        bim_radio: [
          { required: true, message: "请选择指标判断", trigger: "change" },
        ],
        bim_input: [{ required: true, message: "请输入内容", trigger: "blur" }],
        symptom: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个主要症状",
            trigger: "change",
          },
        ],
        symptom_input: [
          { required: true, message: "请输入内容", trigger: "blur" },
        ],
        disease_code: [
          { required: true, message: "请选择疾病状态", trigger: "change" },
        ],
        course_disease: [
          { required: true, message: "请输入病程", trigger: "blur" },
        ],
        course_disease: [
          { required: true, message: "请输入病程", trigger: "blur" },
        ],
        treatment: [
          { required: true, message: "请选择既往治疗", trigger: "change" },
        ],
        treatment_date: [
          { required: true, message: "请选择治疗时间", trigger: "change" },
        ],
        treatment_specific: [
          { required: true, message: "请输入治疗方案", trigger: "blur" },
        ],
        treatment_effect: [
          { required: true, message: "请输入治疗效果", trigger: "blur" },
        ],
        helicobacter_pylori: [
          { required: true, message: "请选择幽门螺杆菌感", trigger: "change" },
        ],
        //----
        allergy_input: [
          { required: true, message: "请输入过敏史", trigger: "blur" },
        ],
        check_false: [
          {
            required: true,
            message: "请选择未进行检查原因",
            trigger: "change",
          },
        ],
        drink_alcohol_quantity: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        drink_alcohol_frequency: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        smoking_history_year: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        smoking_history_quantity: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        //---
        disease_comorbidities_input: [
          { required: true, message: "请输入内容", trigger: "blur" },
        ],
        disease_identify: [
          {
            required: true,
            message: "请选择是否进行鉴别诊断",
            trigger: "change",
          },
        ],
        disease_identify_true: [
          {
            required: true,
            message: "请输入与那些疾病进行鉴别诊断",
            trigger: "blur",
          },
        ],
        disease_identify_false: [
          {
            required: true,
            message: "请输入原因",
            trigger: "blur",
          },
        ],
        disease_diagnosis: [
          { required: true, message: "请选择诊断", trigger: "change" },
        ],
        disease_diagnosis_input: [
          { required: true, message: "请输入内容", trigger: "blur" },
        ],
        check_false_input: [
          { required: true, message: "请输入内容", trigger: "blur" },
        ],
        treatment_plan: [
          { required: true, message: "请选择用药方案", trigger: "change" },
        ],
        // treatment_date: [
        //   { required: true, message: "请选择用药起始时间", trigger: "change" },
        // ],
        treatment_situation: [
          { required: true, message: "请选择合并用药情况", trigger: "change" },
        ],
        treatment_situation_input: [
          { required: true, message: "请输入具体药物及剂量", trigger: "blur" },
        ],
        treatment_return_visit: [
          { required: true, message: "请选择是否回访", trigger: "change" },
        ],
        treatment_untreated: [
          { required: true, message: "请输入未治疗原因", trigger: "blur" },
        ],
        treatment_dose: [
          {
            required: true,
            message: "请选择治疗期间是否调整治疗药物剂量",
            trigger: "change",
          },
        ],
        treatment_dose_input: [
          { required: true, message: "请输入原因", trigger: "blur" },
        ],
        attachments: [
          { required: true, message: "请上传病例照片附件", trigger: "change" },
        ],
        treatment_mg: [{ validator: treatmentDose, trigger: "blur" }],
        gastritis: [{ validator: gastritisVerify, trigger: "blur" }],
        ulcer: [{ validator: ulcerVerify, trigger: "blur" }],
        dyspepsia: [{ validator: dyspepsiaVerify, trigger: "blur" }],
        otherdiseases: [{ validator: otherdiseasesVerify, trigger: "blur" }],
        treatment_plan_other: [
          {
            required: true,
            message: "请输入具体药物名称，剂量，使用周期",
            trigger: "blur",
          },
        ],
        treatment_plan_date: [
          {
            required: true,
            message: "请输入用药周期",
            trigger: "blur",
          },
        ],
        adversereaction: [
          {
            required: true,
            message: "请选择患者是否产生不良反应",
            trigger: "change",
          },
        ],
        adversereaction_group: [
          {
            required: true,
            message: "请选择不良反应表现",
            trigger: "change",
          },
        ],
        adversereaction_group_input: [
          {
            required: true,
            message: "请输入其他",
            trigger: "blur",
          },
        ],
        adversereaction_date: [
          {
            required: true,
            message: "请选择不发生日期",
            trigger: "change",
          },
        ],
        adversereaction_immediately: [
          {
            required: true,
            message: "请选择是否用药后立即发生",
            trigger: "change",
          },
        ],
        adversereaction_time_input: [
          {
            required: true,
            message: "请输入反应发生时间，用药后几小时",
            trigger: "blur",
          },
        ],
        adversereaction_degree: [
          {
            required: true,
            message: "请选择不良反应的严重程度",
            trigger: "change",
          },
        ],
        adversereaction_related: [
          {
            required: true,
            message: "请选择不是否与观察药物相关",
            trigger: "change",
          },
        ],
        adversereaction_strategy: [
          {
            required: true,
            message: "请输入不良反应的应对策略",
            trigger: "blur",
          },
        ],
        //多选检查输入框必填
        //既往检查
        check_true_laboratory: [
          {
            validator: check_true_laboratoryVerify,
            trigger: ["blur", "change"],
          },
        ],
        check_true_image: [
          {
            validator: check_true_imageVerify,
            trigger: ["blur", "change"],
          },
        ],
        check_true_pathology: [
          {
            validator: check_true_pathologyVerify,
            trigger: ["blur", "change"],
          },
        ],
        check_true_other: [
          {
            validator: check_true_otherVerify,
            trigger: ["blur", "change"],
          },
        ],
        //消化疾病相关检查
        digestive_diseases_laboratory: [
          {
            validator: digestive_diseases_laboratoryVerify,
            trigger: ["blur", "change"],
          },
        ],
        digestive_diseases_image: [
          {
            validator: digestive_diseases_imageVerify,
            trigger: ["blur", "change"],
          },
        ],
        digestive_diseases_pathology: [
          {
            validator: digestive_diseases_pathologyVerify,
            trigger: ["blur", "change"],
          },
        ],
        digestive_diseases_other: [
          {
            validator: digestive_diseases_otherVerify,
            trigger: ["blur", "change"],
          },
        ],
        //合并症相关检查
        comorbidities_anxiety: [
          {
            validator: comorbidities_anxietyVerify,
            trigger: ["blur", "change"],
          },
        ],
        comorbidities_depression: [
          {
            validator: comorbidities_depressionVerify,
            trigger: ["blur", "change"],
          },
        ],
        comorbidities_other: [
          {
            validator: comorbidities_otherVerify,
            trigger: ["blur", "change"],
          },
        ],
      },
      //ae
      AElist: [
        {
          c: "轻度",
          t: "受试者可忍受，不影响治疗，不需要特别处理，对受试者康复无影响。",
        },
        {
          c: "中度",
          t: "受试者难以忍受，需要撤药中止试验或做特殊处理，对受试者康复有直接影响。",
        },
        {
          c: "重度",
          t: "危及受试者生命，致死或致残，需立即撤药或做紧急处理。凡严重不良事件请填写严重不良事件报告表，并按规定程序报告。",
        },
      ],
      //悬浮
      showPopover: false,
      tabsList: [
        { top: "基本", bottom: "信息" },
        { top: "临床", bottom: "检查" },
        { top: "疾病", bottom: "诊断" },
        { top: "治疗", bottom: "方案" },
        { top: "疗效", bottom: "评估" },
        { top: "症状", bottom: "评分" },
        { top: "不良", bottom: "反应" },
        { top: "病例", bottom: "照片" },
      ],
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    if (this.$route.query.del != undefined) {
      this.delShow = false;
    }
    if (this.$route.query.id == undefined) {
      this.dialogShow = true; //弹窗; 
    } else {
      this.getformdetail(this.$route.query.id);
    }
    //监听滚动距离
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll, true);
    });
  },
  computed: {
    BMICom() {
      if (this.form.weight != "" && this.form.height != "") {
        let heightNum = this.form.height;
        if (heightNum > 1) {
          heightNum = heightNum / 100;
        }
        this.form.bim = (this.form.weight / (heightNum * heightNum)).toFixed(3);
        //过轻
        if (this.form.bim < 18.5) {
          this.form.bim_radio = 1;
        }
        //正常
        if (this.form.bim >= 18.5 && this.form.bim <= 24.9) {
          this.form.bim_radio = 2;
        }
        //超重
        if (this.form.bim >= 25.0 && this.form.bim <= 29.9) {
          this.form.bim_radio = 3;
        }
        //一级
        if (this.form.bim >= 30.0 && this.form.bim <= 34.9) {
          this.form.bim_radio = 4;
        }
        //二级
        if (this.form.bim >= 35.0 && this.form.bim <= 39.9) {
          this.form.bim_radio = 5;
        }
        //三级
        if (this.form.bim > 40.0) {
          this.form.bim_radio = 6;
        }
      }
      return this.form.bim;
    },
    style1() {
      const length = 4 - 0,
        progress = this.form.pre_degree_pain_chest_ribs - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style2() {
      const length = 4 - 0,
        progress = this.form.pre_degree_epigastric_full - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style3() {
      const length = 4 - 0,
        progress = this.form.pre_degree_be_upset - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style4() {
      const length = 4 - 0,
        progress = this.form.pre_degree_eructation_frequent - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style5() {
      const length = 4 - 0,
        progress = this.form.pre_degree_mild_breathing - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style6() {
      const length = 4 - 0,
        progress = this.form.pre_frequency_pain_chest_ribs - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style7() {
      const length = 4 - 0,
        progress = this.form.pre_frequency_epigastric_full - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style8() {
      const length = 4 - 0,
        progress = this.form.pre_frequency_be_upset - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style9() {
      const length = 4 - 0,
        progress = this.form.pre_frequency_eructation_frequent - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style10() {
      const length = 4 - 0,
        progress = this.form.pre_frequency_mild_breathing - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style11() {
      const length = 4 - 0,
        progress = this.form.post_degree_pain_chest_ribs - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style12() {
      const length = 4 - 0,
        progress = this.form.post_degree_epigastric_full - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style13() {
      const length = 4 - 0,
        progress = this.form.post_degree_be_upset - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style14() {
      const length = 4 - 0,
        progress = this.form.post_degree_eructation_frequent - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style15() {
      const length = 4 - 0,
        progress = this.form.post_degree_mild_breathing - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style16() {
      const length = 4 - 0,
        progress = this.form.post_frequency_pain_chest_ribs - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style17() {
      const length = 4 - 0,
        progress = this.form.post_frequency_epigastric_full - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style18() {
      const length = 4 - 0,
        progress = this.form.post_frequency_be_upset - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style19() {
      const length = 4 - 0,
        progress = this.form.post_frequency_eructation_frequent - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
    style20() {
      const length = 4 - 0,
        progress = this.form.post_frequency_mild_breathing - 0,
        left = (progress / length) * 100;
      return {
        paddingLeft: `${left}%`,
      };
    },
  },
  methods: {
    //页面滚动
    handleScroll(e) {
      let that = this;
      let inref = this.$refs.inref.getBoundingClientRect().top; //临床检查
      let checkref = this.$refs.checkref.getBoundingClientRect().top; //临床检查
      let diagnosisref = this.$refs.diagnosisref.getBoundingClientRect().top; //疾病诊断
      let treatmentref = this.$refs.treatmentref.getBoundingClientRect().top; //治疗
      let evaluateref = this.$refs.evaluateref.getBoundingClientRect().top; //疗效评估
      let zhongyiref = this.$refs.zhongyiref.getBoundingClientRect().top; //中医
      let adversereactionref =
        this.$refs.adversereactionref.getBoundingClientRect().top; //不良反应
      let uploadref = this.$refs.uploadref.getBoundingClientRect().top; //上传

      // if (inref <= 0) {
      //   that.tabsIndex = 0;
      // }
      // if (checkref <= 70) {
      //   that.tabsIndex = 1;
      // }
      // if (diagnosisref <= 70) {
      //   that.tabsIndex = 2;
      // }
      // if (treatmentref <= 70) {
      //   that.tabsIndex = 3;
      // }
      // if (this.form.disease_diagnosis.length != 0) {
      //   if (evaluateref <= 70) {
      //     that.tabsIndex = 4;
      //   }
      // }
      // if (adversereactionref <= 70) {
      //   that.tabsIndex = 5;
      // }
      if (inref <= 0) {
        this.tabsIndex = 0;
      }
      if (checkref <= 70) {
        this.tabsIndex = 1;
      }
      if (diagnosisref <= 70) {
        this.tabsIndex = 2;
      }
      if (treatmentref <= 70) {
        this.tabsIndex = 3;
      }
      if (this.form.disease_diagnosis.length != 0) {
        if (evaluateref <= 70) {
          this.tabsIndex = 4;
        }
      }
      if (this.form.tcm_syndrome_type.length != 0) {
        if (zhongyiref <= 70) {
          this.tabsIndex = 5;
        }
      }
      if (adversereactionref <= 70) {
        this.tabsIndex = 6;
      }
      if (uploadref <= 70) {
        this.tabsIndex = 7;
      }
    },
    handleBtn() {
      this.showPopover = !this.showPopover;
    },
    tabsClick(index) {
      this.tabsIndex = index;
      this.getscrollTop(index);
    },
    //点击滚动
    getscrollTop(index) {
      document.documentElement.scrollTop = 0;
      const checkref = this.$refs.checkref.getBoundingClientRect().top; //临床检查
      const diagnosisref = this.$refs.diagnosisref.getBoundingClientRect().top; //疾病诊断
      const treatmentref = this.$refs.treatmentref.getBoundingClientRect().top; //治疗
      const evaluateref = this.$refs.evaluateref.getBoundingClientRect().top; //疗效评估
      const zhongyiref = this.$refs.zhongyiref.getBoundingClientRect().top; //中医
      const adversereactionref =
        this.$refs.adversereactionref.getBoundingClientRect().top; //不良反应
      let uploadref = this.$refs.uploadref.getBoundingClientRect().top; //上传
      if (index == 0) {
        document.documentElement.scrollTop = 0;
      }
      if (index == 1) {
        document.documentElement.scrollTop = checkref - 60;
      }
      if (index == 2) {
        document.documentElement.scrollTop = diagnosisref - 60;
      }
      if (index == 3) {
        document.documentElement.scrollTop = treatmentref - 60;
      }
      if (index == 4) {
        if (this.form.disease_diagnosis.length != 0) {
          document.documentElement.scrollTop = evaluateref - 60;
        } else {
          document.documentElement.scrollTop = diagnosisref - 60;
        }
      }

      if (index == 5) {
        if (this.form.tcm_syndrome_type.length != 0) {
          document.documentElement.scrollTop = zhongyiref - 60;
        } else {
          document.documentElement.scrollTop = diagnosisref - 60;
        }
      }

      // if (index == 5) {
      //   document.documentElement.scrollTop = adversereactionref - 60;
      // }
      if (index == 6) {
        document.documentElement.scrollTop = adversereactionref - 60;
      }

      if (index == 7) {
        document.documentElement.scrollTop = uploadref - 60;
      }
    },
    //邀请码确认
    confirmCode() {
      // this.$refs.vanform
      //   .validate()
      //   .then(() => {})
      //   .catch(() => {});
    },
    //邀请码关闭前
    async beforeClose(action, done) {
      // new Promise(async (resolve) => {
      if (action == "confirm") {
        try {
          const { data: data } = await this.$http.post(
            "medical/checkInvitationCode",
            { code: this.form.invitation_code }
          );
          if (data.code == 200) {
            return done(true);
          }
        } catch (error) {
          return done(false);
        }
      } else if (action == "cancel") {
        setTimeout(() => {
          done(true);
          this.$router.push("/homeTopic");
        }, 500);
      }
      // });
    },
    //检查邀请码
    async checkCode() {
      const { data: data } = await this.$http.post(
        "medical/checkInvitationCode",
        { code: this.form.invitation_code }
      );
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          this.getsubmitApi();
        } else {
          console.log("error submit!!");
          // this.locateToErr();
          this.scrollToView(this, object);
          return false;
        }
      });
    },
    //提交接口
    async getsubmitApi() {
      const { data: data } = await this.$http.post("auth/medical", this.form);
      if (data.code == 200) {
        this.$toast(data.message);
        this.$router.push("/my");
      }
    },
    //获取详情
    async getformdetail(id) {
      const { data: data } = await this.$http.post("medical/detail", { id });
      this.form = data.data;
      this.form.id = id;
      this.aaa = data.data.attachments;
      this.form.attachments = data.data.attachments;
      this.fileList = data.data.attachments_data;
    },
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName("is-error");
        errorDiv[0].scrollIntoView();
      }, 0);
    },
    //既往检查
    check_true_laboratoryClick(val) {
      if (val == false) {
        this.form.check_true_laboratory = "";
      }
    },
    check_true_imageClick(val) {
      if (val == false) {
        this.form.check_true_image = "";
      }
    },
    check_true_pathologyClick(val) {
      if (val == false) {
        this.form.check_true_pathology = "";
      }
    },
    check_true_otherClick(val) {
      if (val == false) {
        this.form.check_true_other = "";
      }
    },
    //消化疾病相关检查
    digestive_diseases_laboratoryClick(val) {
      if (val == false) {
        this.form.digestive_diseases_laboratory = "";
      }
    },
    digestive_diseases_imageClick(val) {
      if (val == false) {
        this.form.digestive_diseases_image = "";
      }
    },
    digestive_diseases_pathologyClick(val) {
      if (val == false) {
        this.form.digestive_diseases_pathology = "";
      }
    },
    digestive_diseases_otherClick(val) {
      if (val == false) {
        this.form.digestive_diseases_other = "";
      }
    },
    //合并正
    comorbidities_anxietyClick(val) {
      if (val == false) {
        this.form.comorbidities_anxiety = "";
      }
    },
    comorbidities_depressionClick(val) {
      if (val == false) {
        this.form.comorbidities_depression = "";
      }
    },
    comorbidities_otherClick(val) {
      if (val == false) {
        this.form.comorbidities_other = "";
      }
    },
    //上传
    //上传前
    async wenBeforeUpload(file) {
      //获取七牛云的token
      const { data: data } = await this.$http.get("system/qiniuToken");
      this.uploadData.token = data.data.token;
      this.uploadData.key = `medical/${this.year}/${this.month}/${this.day}/${file.uid}${file.name}`;
      return true;
    },
    //文件上传时
    onProgressTest(event, file, fileList) {
      let index = 0;
      // 只有fileList 跟file 里面的uid是唯一的互相对应的
      fileList.forEach((v, i) => {
        if (v.uid === file.uid) {
          index = i;
        }
      });
      // 获取动态的进度
      let percent = parseInt(event.percent);
      this.$nextTick(() => {
        setTimeout(() => {
          if (percent >= 99) {
            // 当动态的进度超过99就获取dom 让值一直显示99直到上传成功
            let dom = document.getElementsByClassName("el-upload-list__item")[
              index
            ];
            let progressText = dom.getElementsByClassName("el-progress__text");
            if (progressText && progressText.length) {
              progressText[0].style.opacity = 0;
              progressText[0].innerText = "99%";
              progressText[0].style.opacity = 1;
            }
          }
        });
      });
    },
    //文件上传成功
    handleAvatarSuccess(res, file) {
      if (res.key != "" || res.key != undefined || res.key != null) {
        this.aaa += `https://resources.wsg.medcase.com.cn/${res.key},`;
        this.form.attachments = this.aaa;
        this.$toast.success("文件上传成功");
      } else {
        this.$toast.fail("上传失败");
      }
    },
    //移除文件 提示
    beforeRemove(file, fileList) {
      return this.$toast.success("移除成功");
    },
    //移除后
    handleRemove(file, fileList) {
      this.aaa = "";
      let qiniuUrl = "";
      let apiUrl = "";
      fileList.map((item) => {
        if (item.response != undefined) {
          qiniuUrl +=
            `https://resources.wsg.medcase.com.cn/${item.response.key}` + ",";
        }
        if (item.url) {
          apiUrl += item.url + ",";
        }
      });
      this.aaa = apiUrl + qiniuUrl;
      this.form.attachments = this.aaa;
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  position: relative;

  .index-head {
    position: relative;
    top: 0;
    left: -16px;
    width: 109%;
    height: 96px;
  }

  // 头
  .index-title {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 17px;

    .index-title-img {
      width: 15px;
      height: 15px;
      margin-right: 3px;
    }

    .index-title-name {
      position: relative;
      font-size: 14px;
      color: #000000;
      font-weight: 600;
      z-index: 1;
    }

    .index-title-xia {
      position: absolute;
      bottom: -1px;
      left: 20px;
      width: 88px;
      height: 7px;
      background-color: #a8efcc;
    }
  }

  // 基本信息
  .biaodan {
    background-color: #f6f8ff;

    //输入框
    .inform-box-input {
      position: relative;

      .form-input-xia {
        position: absolute;
        top: -20px;
        left: 0;
        width: 182px;
      }

      /deep/ .el-input__inner {
        border: none !important;
        border-radius: 0 !important;
        border-bottom: 1px solid #dcdfe6 !important;
        // padding: 0 !important;
        color: #606266;
        font-size: 13px !important;
        height: 20px !important;
        line-height: 20px;
        // background-color: pink;
        padding-left: 15px;
      }

      /deep/ .el-input {
        height: 20px !important;
        line-height: 20px !important;
      }
    }

    //label

    .inform-box-title {
      color: #606266 !important;
      font-size: 14px;
    }

    .inform {
      position: relative;
      left: -16px;
      // top: -20px;
      width: 109%;
      border-radius: 15px 15px 0px 0px;
      padding: 20px 15px;

      background-color: #f6f8ff;

      //内容
      .inform-box {
        position: relative;
        width: 100%;
        background-color: #ffffff;
        border-radius: 6px;
        padding: 18px 12px;

        .inform-box-item-flex {
          position: relative;
          width: 100%;
          display: flex;
          align-items: center;

          /deep/.el-input {
            width: 124px !important;
          }

          .inform-box-item-flex-input-rig {
            margin-left: 8px;
          }
        }

        /deep/ .el-form-item__label {
          line-height: 0 !important;
        }

        /deep/ .el-radio {
          margin-right: 45px;
          margin-top: 24px;
        }

        // /deep/ .el-checkbox {
        //   margin-right: 27px !important;
        //   &:nth-child(7) {
        //     margin-right: 0 !important;
        //   }
        // }
        .inform-box-fen {
          margin-top: 15px;
          display: flex;
          align-items: center;

          .inform-box-fen-left {
            display: flex;
            align-items: center;
            color: #606266;
            margin-right: 5px;
          }

          .inform-box-fen-right {
            display: flex;
            align-items: center;
            color: #606266;
          }
        }

        .inform-box-jiancha {
          padding: 12px;
          background-color: #f5f7f9;
          border-radius: 8px;
          margin-top: 15px;

          .inform-box-jiancha-title {
            color: #2b4fdf;
            margin-bottom: 10px;
          }

          /deep/.el-input__inner {
            background-color: #f5f7f9 !important;
          }
        }

        .inform-box-form-item {
          /deep/.el-form-item__label {
            margin: 10px 0 15px 0;
          }
        }
      }

      .inform-box-lable {
        margin-bottom: 30px;

        /deep/ .el-form-item__label {
          line-height: 40px !important;
        }
      }
    }

    .inform-box-item-flex-name {
      width: 90px;
      color: #606266 !important;

      &::before {
        content: "*";
        position: relative;
        margin-right: 4.4px;
        color: #f56c6c;
      }
    }

    .inform-box-item-flex-shuang {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      margin-left: 10px;

      .inform-box-item-flex-shuang-box {
        display: flex;
        align-items: center;
        position: relative;
        color: #606266 !important;
      }

      /deep/ .el-input__inner {
        // width: 60px !important;
        border: none !important;
        border-radius: 0 !important;
        border-bottom: 1px solid #dcdfe6 !important;
        padding: 0 !important;
        height: 19px !important;
        color: #606266;
        font-size: 13px !important;
      }
    }

    .ping-box {
      display: flex;
      align-items: center;

      .ping-box-img {
        width: 150px;
        height: 24px;
        margin-right: 3px;
      }
    }

    .ping-xiang {
      line-height: 1.5;
    }

    .down-btn {
      background-color: #0ba29a;
      color: #fff;
      border-radius: 18px;
      padding: 10px 0;
      width: 100%;
      text-align: center;
      margin-top: 30px;
    }

    .up-btn {
      background-color: #3887fe;
      color: #fff;
      border-radius: 18px;
      padding: 10px 0;
      width: 100%;
      text-align: center;
      // margin-top: 14px;
      margin: 20px 0;
    }

    .inform-box-buliang {
      margin-top: 15px;
      padding: 18px 10px;
      background-color: #f5f7f9;
      border-radius: 8px;

      /deep/ .el-input__inner {
        background-color: #f5f7f9 !important;
      }

      /deep/ .el-radio {
        margin-right: 25px !important;
      }
    }

    .inform-b-bgc {
      width: 317px;
      height: 237px;
      margin-top: 19px;
      margin-bottom: 10px;
    }
  }

  .zhusu {
    /deep/ .el-checkbox {
      margin-right: 27px !important;

      &:nth-child(7) {
        margin-right: 0 !important;
      }
    }
  }

  .buliang {
    /deep/ .el-checkbox {
      margin-right: 20px !important;

      &:nth-child(4) {
        margin-right: 0 !important;
      }
    }
  }

  .inform-box-xiahuaxian {
    /deep/ .el-input__inner {
      border: none !important;
      border-radius: 0 !important;
      border-bottom: 1px solid #dcdfe6 !important;
      padding: 0 !important;
      color: #606266;
      font-size: 13px !important;
      height: 20px !important;
      line-height: 20px;
    }

    /deep/ .el-input {
      height: 20px !important;
      line-height: 20px !important;
    }
  }

  .fujian {
    width: 345px;

    img {
      width: 100%;
    }
  }

  .form-xing {
    &::after {
      content: "*";
      position: absolute;
      top: 32px;
      left: 7px;
      color: #f56c6c;
    }
  }

  //悬浮
  .xuan {
    position: fixed;
    bottom: 18%;
    right: 2%;
    z-index: 9999999;

    .xuan-ru {
      position: relative;
      z-index: 9999999;

      .xuan-ru-img {
        width: 45px;
        height: 45px;
        transition: all 0.2s linear;

        &.anim {
          transform: rotate(180deg);
        }
      }
    }

    .xuan-ul {
      box-sizing: border-box;
      position: relative;
      top: -6px;
      right: -1px;
      width: 44px;
      // height: 325px;
      // height: 362px;
      // height: 365px;
      height: 415px;
      background: url(../../assets/image/questionnaire/xuan-bgc.png) no-repeat center 0px;
      background-position: center 0px;
      background-size: cover;
      // background-color: #fff;
      padding: 20px 4px;

      .xuan-li {
        font-size: 12px;
        // padding: 6px;
        padding: 6px 5px 6px 0;
        padding-left: 6px;
        line-height: 1.1;
        margin-top: 10px;
        color: #409eff;

        &:nth-child(1) {
          margin-top: 2px;
        }
      }

      .xuan-li-active {
        font-size: 12px;
        background-image: linear-gradient(#96fcf6, #346ad8);
        color: #fff;
        border-radius: 11px;
      }
    }
  }

  .zhongyi-head {
    color: #000000;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .zhongyi-text {
    border-radius: 8px;
    background-color: #e6f4ff;
    font-size: 13px;
    color: #111111;
    display: flex;
    padding: 16px 8px;
    margin-bottom: 25px;

    .zhongyi-text-zhu {
      color: #ff2d2d;
    }

    .zhongyi-text-name {
      & div {
        margin-bottom: 9px;
      }

      & div:last-child {
        margin-bottom: 0;
      }
    }
  }

  .zhongyi-box {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 20px;
    }

    .zhongyi-box-head {
      margin-right: 15px;
      width: 65px;
    }

    .zhongyi-box-slider {
      position: relative;

      .zhongyi-box-slider-item {
        width: 225px;
      }

      .form-zhongyi-box-slider-cen-name {
        position: absolute;
        // top: 10px;
        // left: -3.5px;
        top: 11px;
        left: -4px;
        z-index: 9999;
        color: #000;
        font-size: 13px;

        width: 0px;
        height: 0px;
      }

      .form-zhongyi-box-slider-cen-name1 {
        position: absolute;
        top: 11px;
        left: -3px;
        z-index: 9999;
        color: #000;
        font-size: 13px;
        width: 0px;
        height: 0px;
      }

      .form-zhongyi-box-slider-cen-zheng {
        position: absolute;
        top: 35px;
        left: -12px;
        z-index: 9999;
        font-size: 12px;
        color: #656f95;

        .zhong-zheng1 {
          position: absolute;
          top: 0px;
          left: -5px;
          width: 40px;
        }

        .zhong-zheng5 {
          position: absolute;
          top: 0px;
          right: -35px;
          width: 40px;
        }
      }

      // 后
      .form-zhongyi-box-slider-cen-zheng-hou {
        position: absolute;
        top: 35px;
        left: -12px;
        z-index: 9999;
        font-size: 12px;
        color: #656f95;

        .zhong-zheng1-hou {
          position: absolute;
          top: 0px;
          left: 5px;
          width: 40px;
        }

        .zhong-zheng2-hou {
          position: absolute;
          top: 0px;
          left: 53px;
          width: 40px;
        }

        .zhong-zheng3-hou {
          position: absolute;
          top: 0px;
          left: 100px;
          width: 60px;
        }

        .zhong-zheng4-hou {
          position: absolute;
          top: 0px;
          right: -50px;
          width: 60px;
        }

        .zhong-zheng5-hou {
          position: absolute;
          top: 0px;
          right: -40px;
          width: 40px;
        }
      }
    }
  }

  /deep/ .el-slider__bar {
    height: 8px;
    background: linear-gradient(90deg, #ffe6e6 0%, #db1f1f 100%);
  }

  /deep/ .el-slider__runway {
    height: 8px;
  }

  /deep/.el-slider__stop {
    width: 8px;
    height: 8px;
  }

  /deep/.el-slider__button {
    position: relative;
    /* border-color: #db1f1f; */
    border: 4px solid #cdcccf !important;
    width: 23px;
    height: 23px;
  }

  /deep/ .el-slider__marks-text {
    color: #000;
  }
}

.ques /deep/ .el-input.is-disabled .el-input__inner {
  color: #606266 !important;
}

.ques /deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #606266 !important;
}

.ques /deep/ .el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  background-color: #606266 !important;
}

.ques /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #606266 !important;
}

// .upload-demo {
//   background-color: #fff;
// }
// .upload-demo /deep/.el-upload-list {
//   background-color: #fff;
// }
</style>
